var _defs, _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _rect, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _g3, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _rect2, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _rect3, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _rect4, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _rect5, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _rect6, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _rect7, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _rect8, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _rect9, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAchievementsVisual({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 292,
    height: 194,
    viewBox: "0 0 292 194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19429",
    "data-name": "Rectangle 19429",
    d: "M0,0H292a0,0,0,0,1,0,0V169a25,25,0,0,1-25,25H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(1049.293 366.821)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18736",
    "data-name": "Rectangle 18736",
    width: 338,
    height: 194,
    transform: "translate(0.236 -0.447)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18705",
    "data-name": "Rectangle 18705",
    width: 43.992,
    height: 47.736,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18706",
    "data-name": "Rectangle 18706",
    width: 23.028,
    height: 24.989,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18710",
    "data-name": "Rectangle 18710",
    width: 8.866,
    height: 48.862,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_141",
    "data-name": "Mask Group 141",
    transform: "translate(-1049.293 -366.821)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77434",
    "data-name": "Group 77434",
    transform: "translate(1027.056 367.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44617",
    "data-name": "Group 44617",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44616",
    "data-name": "Group 44616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44615",
    "data-name": "Group 44615",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_138909",
    "data-name": "Path 138909",
    d: "M742.171,350.094s5.8,23.456,21.816,19.026c0,0-3.161-15.877-21.816-19.026",
    transform: "translate(-664.016 -310.224)",
    fill: "#3f9896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138910",
    "data-name": "Path 138910",
    d: "M845.567,169.646S838.2,210.7,866.075,216.98c0,0,6.166-27.162-20.507-47.334",
    transform: "translate(-755.763 -150.346)",
    fill: "#7fc6a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138911",
    "data-name": "Path 138911",
    d: "M744.517,350.094s5.8,23.456,21.816,19.026c0,0-3.161-15.877-21.816-19.026",
    transform: "translate(-666.116 -310.224)",
    fill: "#3f9896"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138912",
    "data-name": "Path 138912",
    d: "M847.913,169.646S840.549,210.7,868.42,216.98c0,0,6.166-27.162-20.507-47.334",
    transform: "translate(-757.862 -150.346)",
    fill: "#7fc6a6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44605",
    "data-name": "Group 44605",
    transform: "translate(269.005 37.552)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44604",
    "data-name": "Group 44604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44603",
    "data-name": "Group 44603",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138914",
    "data-name": "Path 138914",
    d: "M2598.124,348.687l3.7-3.182-1.514-3.091-1.515-3.091-4.5,1.544a18.137,18.137,0,0,0-4.442-3.974l.54-5.087-3.085-1.024-3.085-1.024-2.175,4.544a16.408,16.408,0,0,0-5.73.6l-2.933-4.011-2.849,1.643-2.849,1.643,1.423,4.882a19,19,0,0,0-3.662,4.82l-4.688-.586-.944,3.348-.944,3.348,4.188,2.36a20.833,20.833,0,0,0,.55,6.218l-3.7,3.182,1.514,3.091,1.514,3.091,4.5-1.544a18.144,18.144,0,0,0,4.442,3.974l-.54,5.087,3.085,1.024,3.085,1.024,2.175-4.544a16.4,16.4,0,0,0,5.73-.6l2.933,4.011,2.849-1.643,2.849-1.643-1.423-4.882a18.99,18.99,0,0,0,3.662-4.82l4.688.586.944-3.348.944-3.348-4.188-2.36a20.817,20.817,0,0,0-.55-6.218m-5.683,8.78c-1.955,6.937-8.723,10.84-15.115,8.718s-9.99-9.465-8.034-16.4,8.723-10.84,15.115-8.718,9.99,9.465,8.034,16.4",
    transform: "translate(-2558.87 -329.757)",
    fill: "#ffc47d"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44608",
    "data-name": "Group 44608",
    transform: "translate(230.068 12.831)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44607",
    "data-name": "Group 44607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44606",
    "data-name": "Group 44606",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138915",
    "data-name": "Path 138915",
    d: "M2211.258,125.8l-.189-1.8-.189-1.8-2.437-.182a10.24,10.24,0,0,0-1.445-2.829l1.15-2.339-1.307-1.129-1.307-1.129-1.843,1.741a8.638,8.638,0,0,0-2.865-.892l-.711-2.536-1.66.2-1.66.2-.168,2.645a9,9,0,0,0-2.607,1.568l-2.156-1.248-1.04,1.418-1.04,1.418,1.6,2a10.626,10.626,0,0,0-.823,3.109l-2.337.772.189,1.8.189,1.8,2.437.182a10.233,10.233,0,0,0,1.445,2.829l-1.15,2.339,1.307,1.129,1.307,1.129,1.842-1.741a8.648,8.648,0,0,0,2.865.892l.711,2.536,1.66-.2,1.659-.2.168-2.644a9,9,0,0,0,2.607-1.568l2.156,1.248,1.04-1.418,1.04-1.418-1.6-2a10.627,10.627,0,0,0,.822-3.109Zm-6.61,3.831a5.941,5.941,0,0,1-8.806,1.087,7.2,7.2,0,0,1-1-9.555,5.941,5.941,0,0,1,8.806-1.087,7.2,7.2,0,0,1,1,9.555",
    transform: "translate(-2188.23 -112.901)",
    fill: "#ffc47d"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138916",
    "data-name": "Path 138916",
    d: "M1373.479,161.459c-.181-.423-.493-1.3-.91-2.3-.8.329-1.421.561-1.47.463l-.166.1a.162.162,0,0,1-.133.014c-.77.436-1.738,1.016-2.576,1.444-.6.3-1.194.349-1.307,1.027a9.587,9.587,0,0,0,.805,2.6l1.41,3.933c1.025-.571,5.876-1.168,5.951-1.437l-1.67-5.631Z",
    transform: "translate(-1223.127 -141.056)",
    fill: "#fe9f73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138917",
    "data-name": "Path 138917",
    d: "M1317.835,184.447c1.414-.769.793-2.143,3.867-6.095s9.063-5.586,9.063-5.586l.569-1.52-15.792,5.623Z",
    transform: "translate(-1177.154 -151.764)",
    fill: "#ffb96c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138918",
    "data-name": "Path 138918",
    d: "M1300.172,156.243c-4.635-1.207-4.885-2.712-6.443-2.423l2.292,7.578,15.792-5.623-1.289-.858s-5.716,2.534-10.351,1.327",
    transform: "translate(-1157.632 -136.292)",
    fill: "#ffc47d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138919",
    "data-name": "Path 138919",
    d: "M1508.938,205.93l-1.368.487,1.3,4.3a18.207,18.207,0,0,1-4.192-.228c-3.532-.627-6.023-2.266-7.4-4.871l-1.248.779c1.589,3,4.514,4.95,8.458,5.641a18.8,18.8,0,0,0,5.45.147.718.718,0,0,0,.513-.36.84.84,0,0,0,.074-.658Z",
    transform: "translate(-1338.677 -182.219)",
    fill: "#ffae55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138920",
    "data-name": "Path 138920",
    d: "M1473.9.051a.67.67,0,0,0-.61.04,20.621,20.621,0,0,0-4.31,3.623c-2.8,3.092-4.091,6.544-3.733,9.982l1.431-.175c-.31-2.986.8-5.908,3.3-8.684a20.137,20.137,0,0,1,3.252-2.879l1.3,4.3,1.368-.487L1474.322.534a.758.758,0,0,0-.418-.483",
    transform: "translate(-1311.081 -0.036)",
    fill: "#ffae55"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138921",
    "data-name": "Path 138921",
    d: "M1452.708,128.441c3.295,8.871,19.98,3.7,19.98,3.7l-2.954-9.767Z",
    transform: "translate(-1299.91 -108.466)",
    fill: "#ffb96c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138922",
    "data-name": "Path 138922",
    d: "M1450.981,52.527l17.026-6.063-2.954-9.767s-16.262,6.565-14.072,15.83",
    transform: "translate(-1298.182 -32.553)",
    fill: "#ffc47d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138923",
    "data-name": "Path 138923",
    d: "M1448.164,175.046l-.718.256.475,1.57a.373.373,0,0,0,.477.262.419.419,0,0,0,.241-.518Z",
    transform: "translate(-1295.2 -155.131)",
    fill: "#ffb96c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138924",
    "data-name": "Path 138924",
    d: "M1443.005,158.815a.419.419,0,0,0-.241.518l.475,1.57.718-.256-.475-1.57a.372.372,0,0,0-.477-.262",
    transform: "translate(-1290.993 -140.732)",
    fill: "#ffc47d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139229",
    "data-name": "Path 139229",
    d: "M.511.037,1.977,0,1.467,21.824,0,21.861Z",
    transform: "matrix(0.95, -0.312, 0.312, 0.95, 164.787, 4.08)",
    fill: "#ffae55"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138925",
    "data-name": "Path 138925",
    d: "M1282.089,146.018a.078.078,0,0,0-.1-.055l-.918.327a.087.087,0,0,0-.051.108l5.127,16.952a.078.078,0,0,0,.1.055l.918-.327a.088.088,0,0,0,.051-.108Z",
    transform: "translate(-1146.254 -129.359)",
    fill: "#ffae55"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138926",
    "data-name": "Path 138926",
    d: "M1394.566,159.979a1.084,1.084,0,0,0-.912-.117.8.8,0,0,0-.541.68l.809,2.539a.638.638,0,0,0,.864.319.8.8,0,0,0,.586-.893Z",
    transform: "translate(-1246.572 -141.624)",
    fill: "#fe9f73"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138927",
    "data-name": "Path 138927",
    d: "M1380.658,164.287a.783.783,0,0,0-.731-.023c-.452.179-.728.563-.7.645l.807,2.764a.63.63,0,0,0,.852.335.8.8,0,0,0,.6-.887Z",
    transform: "translate(-1234.142 -145.512)",
    fill: "#fe9f73"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138928",
    "data-name": "Path 138928",
    d: "M1393.118,160.579a.121.121,0,0,0-.17-.053.148.148,0,0,0-.1.164l.8,2.5a.489.489,0,0,1-.076.418.794.794,0,0,1-.4.307.518.518,0,0,1-.7-.262l-.86-2.74a.121.121,0,0,0-.17-.053.158.158,0,0,0-.106.14.093.093,0,0,0,0,.025l.86,2.74a.756.756,0,0,0,1.025.375,1.159,1.159,0,0,0,.584-.448.726.726,0,0,0,.111-.612Z",
    transform: "translate(-1244.979 -142.254)",
    fill: "#ef7162"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138929",
    "data-name": "Path 138929",
    d: "M1408.552,156.19c-.086-.285-.546-.376-.81-.277-.455.171-.725.566-.7.649l.829,2.751a.628.628,0,0,0,.835.34.806.806,0,0,0,.62-.9Z",
    transform: "translate(-1259.039 -138.144)",
    fill: "#fe9f73"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138930",
    "data-name": "Path 138930",
    d: "M1407.633,158.065a.12.12,0,0,0-.169-.055.149.149,0,0,0-.1.164l.759,2.518a.494.494,0,0,1-.082.419.8.8,0,0,1-.4.3.514.514,0,0,1-.7-.271l-.818-2.757a.12.12,0,0,0-.169-.055.159.159,0,0,0-.108.139.09.09,0,0,0,0,.025l.818,2.757a.75.75,0,0,0,1.017.387,1.162,1.162,0,0,0,.589-.443.733.733,0,0,0,.12-.613Z",
    transform: "translate(-1257.969 -140.025)",
    fill: "#ef7162"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138931",
    "data-name": "Path 138931",
    d: "M1380.48,164.043a.12.12,0,0,0-.168-.056.148.148,0,0,0-.1.163l.828,2.834a.5.5,0,0,1-.085.419.8.8,0,0,1-.4.3.471.471,0,0,1-.657-.267l-.74-2.711a.119.119,0,0,0-.167-.058.159.159,0,0,0-.11.141.1.1,0,0,0,0,.021l.741,2.713a.706.706,0,0,0,.977.387,1.164,1.164,0,0,0,.592-.44.736.736,0,0,0,.125-.613Z",
    transform: "translate(-1233.828 -145.321)",
    fill: "#ef7162"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138932",
    "data-name": "Path 138932",
    d: "M1405.144,183.033a.734.734,0,0,0-1.074.064.77.77,0,0,0-.211.981l1.328,2.613a2.629,2.629,0,0,0,1.31-.523c.232-.19.426-.675.248-.921Z",
    transform: "translate(-1256.101 -162.026)",
    fill: "#fe9f73"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138933",
    "data-name": "Path 138933",
    d: "M1404.059,181.888a.635.635,0,0,0-.558-.242,1.155,1.155,0,0,0-.695.3.92.92,0,0,0-.279,1.179l1.342,2.639a.084.084,0,0,0,.018.018.168.168,0,0,0,.227-.211l-1.341-2.639a.63.63,0,0,1,.187-.811.79.79,0,0,1,.475-.2.428.428,0,0,1,.382.165l1.57,2.171a.134.134,0,0,0,.19,0,.147.147,0,0,0,.054-.191Z",
    transform: "translate(-1254.894 -160.978)",
    fill: "#ef7162"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138934",
    "data-name": "Path 138934",
    d: "M1368.1,171.643a.723.723,0,0,0-.679-.029c-.422.163-.684.518-.662.6l.714,2.589a.583.583,0,0,0,.788.321.753.753,0,0,0,.572-.822Z",
    transform: "translate(-1222.987 -152.032)",
    fill: "#fe9f73"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138935",
    "data-name": "Path 138935",
    d: "M1368.011,171.247a.119.119,0,0,0-.167-.058.15.15,0,0,0-.106.163l.732,2.655a.458.458,0,0,1-.083.384.73.73,0,0,1-.374.273.465.465,0,0,1-.629-.26l-.714-2.589a.119.119,0,0,0-.167-.058.159.159,0,0,0-.11.141.085.085,0,0,0,0,.021l.714,2.589a.7.7,0,0,0,.946.382,1.1,1.1,0,0,0,.562-.41.7.7,0,0,0,.125-.578Z",
    transform: "translate(-1222.662 -151.703)",
    fill: "#ef7162"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138936",
    "data-name": "Path 138936",
    d: "M1479.109,1575.222l8.317.125.131-9.45-8.282-1.234Z",
    transform: "translate(-1323.537 -1386.34)",
    fill: "#fe9f73"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138937",
    "data-name": "Path 138937",
    d: "M1727.363,1539.3l1.922,10.358,8.324-1.794-1.737-9.266Z",
    transform: "translate(-1545.711 -1363.244)",
    fill: "#fe9f73"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138938",
    "data-name": "Path 138938",
    d: "M1465.266,873.609l-11.44-4.7a3.06,3.06,0,0,0-4.131,2.564l-.054.375a3.5,3.5,0,0,0-.035.552l1.153,75.99a3.269,3.269,0,0,0,2.188,3.091,22.078,22.078,0,0,0,6.748,1.088,3.141,3.141,0,0,0,3.041-2.884c2.836-24.974,4.185-63.145,4.5-72.9a3.288,3.288,0,0,0-1.965-3.172",
    transform: "translate(-1297.132 -769.702)",
    fill: "#33192c"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138939",
    "data-name": "Path 138939",
    d: "M1536.744,885.165c-2.558-21.382-2.712-40.77-2.712-40.77L1510.8,837.1l5.794,17.991,5.4,33.083,8.919,32.721a2.661,2.661,0,0,0,2.223,2.123,21.879,21.879,0,0,0,7.71-.419,2.752,2.752,0,0,0,2.03-2.9c-.656-10.341-4.716-22.67-6.136-34.541",
    transform: "translate(-1351.898 -741.716)",
    fill: "#49263e"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138940",
    "data-name": "Path 138940",
    d: "M1582.078,1092.278l-4.029-24.663a.132.132,0,0,0-.152-.114.14.14,0,0,0-.107.162l4.032,24.678,0,.007,8.6,31.536a.132.132,0,0,0,.126.1.119.119,0,0,0,.037-.006.142.142,0,0,0,.089-.174Z",
    transform: "translate(-1411.85 -945.849)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138941",
    "data-name": "Path 138941",
    d: "M1736.275,1028.034c-.022-.142-.037-.24-.052-.305h0c0-.064-.007-.155-.017-.285l-1.972-25.6a.134.134,0,0,0-.142-.129.138.138,0,0,0-.12.152c.02.257,1.972,25.58,1.993,25.888,0,0,0,.006,0,.009l.015.138h.007c.008.048.017.109.028.183.76,4.931,2.183,13.883,3.167,18.443a.134.134,0,0,0,.128.109.122.122,0,0,0,.03,0,.142.142,0,0,0,.1-.169c-.982-4.553-2.4-13.5-3.164-18.426",
    transform: "translate(-1551.625 -887.561)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138942",
    "data-name": "Path 138942",
    d: "M1450.192,1003.68a.136.136,0,0,0-.13.143l.935,61.594a.136.136,0,0,0,.132.139h0a.137.137,0,0,0,.129-.143l-.935-61.594a.132.132,0,0,0-.134-.139",
    transform: "translate(-1297.542 -889.305)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138943",
    "data-name": "Path 138943",
    d: "M1409.434,1641.5h-7.293l-2.957-3.445-5.408,3.445h-1.165a.864.864,0,0,0-.845.712.874.874,0,0,0,.814,1.064h16.958a.234.234,0,0,0,.225-.241v-1.182a.342.342,0,0,0-.329-.353",
    transform: "translate(-1245.355 -1451.369)",
    fill: "#33182c"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138944",
    "data-name": "Path 138944",
    d: "M1413.507,1629.175a4,4,0,0,1-5.322-.451l-6.192,2.938s-1.7.607-2.158,1.581h16.771v-3.2a2.508,2.508,0,0,0-3.1-.866",
    transform: "translate(-1252.59 -1443.098)",
    fill: "#49263e"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18708",
    "data-name": "Rectangle 18708",
    width: 0.124,
    height: 3.187,
    transform: "translate(163.953 186.943)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138945",
    "data-name": "Path 138945",
    d: "M1502.205,1633l-.018.131a2.684,2.684,0,0,0,.384.023,4.367,4.367,0,0,0,2.57-.846l-.07-.109a4.166,4.166,0,0,1-2.866.8",
    transform: "translate(-1344.19 -1446.179)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138946",
    "data-name": "Path 138946",
    d: "M1544.465,1657.722l.069.11.791-.571-.069-.11Z",
    transform: "translate(-1382.027 -1468.285)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138947",
    "data-name": "Path 138947",
    d: "M1539.067,1656.308l.069.11.791-.571-.069-.11Z",
    transform: "translate(-1377.196 -1467.033)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138948",
    "data-name": "Path 138948",
    d: "M1408.819,1667.754h-16.768a.926.926,0,0,0-.892.954.981.981,0,0,0,.315.728l.08-.1a.845.845,0,0,1-.271-.627.8.8,0,0,1,.768-.822h16.768a.367.367,0,0,1,.354.379v.885h.124v-.885a.5.5,0,0,0-.478-.512",
    transform: "translate(-1244.826 -1477.679)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138949",
    "data-name": "Path 138949",
    d: "M1400.737,1631.386a3.141,3.141,0,0,0-1.621,1.354l.112.057a3.09,3.09,0,0,1,1.558-1.289c1.246-.569,6.725-3.168,6.781-3.195l-.051-.121c-.055.026-5.533,2.625-6.779,3.194",
    transform: "translate(-1251.947 -1442.627)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138950",
    "data-name": "Path 138950",
    d: "M1685.982,1622.925a.327.327,0,0,0-.408-.241l-7.009,2.158-3.733-2.436-4.306,4.911-1.119.344a.906.906,0,0,0-.628.934.837.837,0,0,0,1.058.781l16.3-5.018a.244.244,0,0,0,.154-.3Z",
    transform: "translate(-1493.278 -1437.5)",
    fill: "#33182c"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138951",
    "data-name": "Path 138951",
    d: "M1686.79,1593.757s-2.163,2.9-5.231,1.141l-5.191,4.656s-1.475,1.086-1.664,2.158l16.116-4.963-.828-3.078a2.463,2.463,0,0,0-3.2.085",
    transform: "translate(-1498.583 -1411.538)",
    fill: "#49263e"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138952",
    "data-name": "Path 138952",
    d: "M1819.661,1597.974l.824,3.062.119-.037-.824-3.062Z",
    transform: "translate(-1628.313 -1415.821)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138953",
    "data-name": "Path 138953",
    d: "M1765.054,1600.089l.016.132a2.777,2.777,0,0,0,.375-.092,4.555,4.555,0,0,0,2.251-1.573l-.1-.084a4.318,4.318,0,0,1-2.547,1.618",
    transform: "translate(-1579.442 -1416.294)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138954",
    "data-name": "Path 138954",
    d: "M1811.947,1617.136l.1.085.613-.782-.1-.085Z",
    transform: "translate(-1621.409 -1432.138)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138955",
    "data-name": "Path 138955",
    d: "M1806.362,1617.25l.1.085.612-.782-.095-.085Z",
    transform: "translate(-1616.411 -1432.239)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138956",
    "data-name": "Path 138956",
    d: "M1684.967,1624.4l-16.113,4.962a.967.967,0,0,0-.61,1.181.936.936,0,0,0,.491.606l.051-.121a.808.808,0,0,1-.423-.522.832.832,0,0,1,.526-1.017l16.113-4.961a.352.352,0,0,1,.438.259l.229.851.119-.037-.229-.851a.475.475,0,0,0-.592-.35",
    transform: "translate(-1492.77 -1439.254)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138957",
    "data-name": "Path 138957",
    d: "M1675.139,1613.483a3.308,3.308,0,0,0-1.207,1.781l.122.021a3.257,3.257,0,0,1,1.164-1.7c1.051-.915,5.644-5.035,5.69-5.076l-.08-.1c-.046.041-4.639,4.16-5.689,5.075",
    transform: "translate(-1497.893 -1425.098)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138958",
    "data-name": "Path 138958",
    d: "M1384.24,232.03s2.2,23.581,3.016,26.148c.363,1.136,4.432,8.488,4.432,8.488l7.612-4.978-4.878-11.585Z",
    transform: "translate(-1238.634 -205.619)",
    fill: "#fe9f73"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138959",
    "data-name": "Path 138959",
    d: "M1751.962,292l-6.795,10.386,6.615,6.44s5.269-6.393,5.822-7.435c1.249-2.354,7.485-25.069,7.485-25.069l-6.339-1.823Z",
    transform: "translate(-1561.645 -243.25)",
    fill: "#fe9f73"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138960",
    "data-name": "Path 138960",
    d: "M1870.991,195.926a.613.613,0,0,0-.853.211l-1.2,1.852a.147.147,0,0,1-.167.064.17.17,0,0,1-.093-.236l1.418-2.965a.563.563,0,0,0-.321-.812.793.793,0,0,0-.911.424l-1.446,3.023a.148.148,0,0,1-.178.083l-.05-.016a.168.168,0,0,1-.1-.205l.97-3.629a.715.715,0,0,0-.383-.854.62.62,0,0,0-.819.451l-.977,3.651a.151.151,0,0,1-.189.113l-.157-.049a.167.167,0,0,1-.108-.184l.493-3.491a.7.7,0,0,0-.482-.793.634.634,0,0,0-.758.563s-1.015,5.28-1.236,6.091l-1.158-1.521a.6.6,0,0,0-.854-.269.713.713,0,0,0-.248.927l1.526,4.071c.109.215.544.354.918.374a48.475,48.475,0,0,0,4.991,1.888l.977-4.172a10.668,10.668,0,0,1,1.42-3.359l.165-.255a.717.717,0,0,0-.189-.976",
    transform: "translate(-1665.402 -170.637)",
    fill: "#fe9f73"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138961",
    "data-name": "Path 138961",
    d: "M1592.332,400.755s-.911,2.251.831,3.318l-2.087,4.283c-.536,1.08.342,1.055,1.222,1.825a6.09,6.09,0,0,0,1.637,1.03,3.6,3.6,0,0,0,4.352-1.122,36.255,36.255,0,0,0,1.432-5.106l.789-1.987,2.569-7.906-8.31-1.1Z",
    transform: "translate(-1423.595 -349.114)",
    fill: "#fe9f73"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138962",
    "data-name": "Path 138962",
    d: "M1644.281,428.7a.1.1,0,0,0-.061.128.093.093,0,0,0,.118.067c1.286-.441,1.927,1.188,1.953,1.258a.1.1,0,0,0,.053.056.087.087,0,0,0,.07,0,.106.106,0,0,0,.051-.134c-.007-.019-.733-1.872-2.185-1.375",
    transform: "translate(-1471.298 -379.794)",
    fill: "#49263e"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138963",
    "data-name": "Path 138963",
    d: "M1620.281,414.537a.1.1,0,0,0-.058.13.092.092,0,0,0,.12.063c.554-.21,1.055.8,1.06.815a.1.1,0,0,0,.049.048.087.087,0,0,0,.078,0,.107.107,0,0,0,.04-.138c-.023-.048-.582-1.181-1.289-.913",
    transform: "translate(-1449.821 -367.285)",
    fill: "#49263e"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138964",
    "data-name": "Path 138964",
    d: "M1646.449,437.679a.277.277,0,0,0-.366.174.316.316,0,0,0,.161.4.276.276,0,0,0,.366-.174.316.316,0,0,0-.161-.4",
    transform: "translate(-1472.952 -387.806)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138965",
    "data-name": "Path 138965",
    d: "M1620.761,424.757a.276.276,0,0,0-.366.174.316.316,0,0,0,.161.4.276.276,0,0,0,.366-.174.316.316,0,0,0-.161-.4",
    transform: "translate(-1449.962 -376.357)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138966",
    "data-name": "Path 138966",
    d: "M1616.988,348.27a3.3,3.3,0,0,0-4.1-.891c-1.07.83-2.157,1.6-.674,4.793s6.616,3.2,6.616,3.2l2.284-1.637s.261-.288.612-.742-.625-2.389-1.581-3.673-2.281-.1-3.153-1.053",
    transform: "translate(-1442.008 -307.488)",
    fill: "#49263e"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138967",
    "data-name": "Path 138967",
    d: "M1673.492,397.365l-.005.7-1.966,2.394-1.787,7.349c2.641,1.485,3.778-2.94,4.025-3.564s1.407-1.41,1.6-3.769a3.024,3.024,0,0,0-1.87-3.112",
    transform: "translate(-1494.136 -352.107)",
    fill: "#49263e"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138968",
    "data-name": "Path 138968",
    d: "M1668.513,436.433a1.658,1.658,0,0,0-2.2,1.046,1.9,1.9,0,0,0,.964,2.386,1.659,1.659,0,0,0,2.2-1.046,1.9,1.9,0,0,0-.964-2.386",
    transform: "translate(-1490.971 -386.609)",
    fill: "#fe9f73"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138969",
    "data-name": "Path 138969",
    d: "M1678.1,445.653a.915.915,0,0,0-.628.454l-.1.15.155-.073a.7.7,0,0,1,.878.24.668.668,0,0,1-.032.766.583.583,0,0,1-.7.24l-.009,0a.046.046,0,0,0-.061.028.053.053,0,0,0,.026.067l.009,0a.677.677,0,0,0,.813-.273.768.768,0,0,0-.809-1.21.753.753,0,0,1,.471-.287,1.016,1.016,0,0,1,.72.248.045.045,0,0,0,.066-.007.054.054,0,0,0-.006-.072,1.091,1.091,0,0,0-.792-.271",
    transform: "translate(-1500.971 -394.884)",
    fill: "#f07162"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138970",
    "data-name": "Path 138970",
    d: "M1603.27,481.451l-1.064,2.144c4.539,1.5,6.041-2.275,6.041-2.275-2.342,1.966-4.977.131-4.977.131",
    transform: "translate(-1433.702 -426.491)",
    fill: "#f07162"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138971",
    "data-name": "Path 138971",
    d: "M1605.585,425.557c-.445.971-1.627,3.6-1.9,3.618-.388.031-4.937-2.751-5.72-2.575,0,0-2.224,4.34.522,5.692,3.93,1.934,5.213-.387,6.183-2.32l1.551-4.18.31-1.273a2.257,2.257,0,0,0-.944,1.038",
    transform: "translate(-1429.144 -376.165)",
    fill: "#49263e"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138972",
    "data-name": "Path 138972",
    d: "M1623.982,426.676a.045.045,0,0,0-.064.02l-1.125,2.205.827.743a.045.045,0,0,0,.066-.007.054.054,0,0,0-.006-.072l-.767-.689,1.087-2.131a.053.053,0,0,0-.019-.069",
    transform: "translate(-1452.126 -378.071)",
    fill: "#f07162"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138973",
    "data-name": "Path 138973",
    d: "M1618.268,457.769c.63.288,1.153-.361,1.153-.361-.025-.017-1.722-.786-1.722-.786s-.062.86.568,1.147",
    transform: "translate(-1447.566 -404.609)",
    fill: "#fbfdfc"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138974",
    "data-name": "Path 138974",
    d: "M1680.745,923.121l-2.924,2.867a.144.144,0,0,0-.009.193.122.122,0,0,0,.081.044.119.119,0,0,0,.1-.034l2.924-2.867a.145.145,0,0,0,.009-.193.119.119,0,0,0-.178-.01",
    transform: "translate(-1501.336 -817.898)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138975",
    "data-name": "Path 138975",
    d: "M1678.691,943.721l-2.207,2.129a.145.145,0,0,0-.01.193.123.123,0,0,0,.082.045.119.119,0,0,0,.1-.034l2.207-2.129a.145.145,0,0,0,.011-.193.119.119,0,0,0-.178-.011",
    transform: "translate(-1500.139 -836.151)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138976",
    "data-name": "Path 138976",
    d: "M1425.788,252.911l-10.364,10.626s-14.637-.959-15.713-1.513-7.94-13.917-7.809-13.728-3.577-18.225-3.577-18.225-5.148-.189-7.2.615c0,0,2.356,23.752,2.966,25.533s1.584,3.832,1.584,3.832c1.305,3.021,5.308,10.822,5.308,10.822-.062,1.824-3.029,37.1-3.029,37.1s5.43,6.476,30.25,6.59c0,0,1.063-35.941,1.824-37.638.625-1.393,8.384-10.128,11.141-13.211a6.5,6.5,0,0,0,1.386-2.517l6.735-23.081s-5.029-2.6-6.774-2.651Z",
    transform: "translate(-1235.847 -203.865)",
    fill: "#defaff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138977",
    "data-name": "Path 138977",
    d: "M1679.509,430.047l-1.345-.724-.056.057-10.329,10.59-4.512-.32a.115.115,0,0,0-.117.112.117.117,0,0,0,.1.127l4.608.326.035-.036,10.308-10.569,1.207.649a.107.107,0,0,0,.148-.054.125.125,0,0,0-.05-.161",
    transform: "translate(-1488.243 -380.423)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138978",
    "data-name": "Path 138978",
    d: "M1812.1,276.52a.108.108,0,0,0-.145.064l-6.729,17.444a.124.124,0,0,0,.059.157.1.1,0,0,0,.043.009.111.111,0,0,0,.1-.074l6.729-17.444a.124.124,0,0,0-.059-.157",
    transform: "translate(-1615.382 -245.029)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138979",
    "data-name": "Path 138979",
    d: "M1738.315,640.214a.112.112,0,0,0-.118.111c-.01.153-1.045,15.388-1.432,25.725a.116.116,0,0,0,.106.125h0a.115.115,0,0,0,.11-.115c.387-10.333,1.421-25.565,1.431-25.717a.117.117,0,0,0-.1-.128",
    transform: "translate(-1554.125 -567.272)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138980",
    "data-name": "Path 138980",
    d: "M1454.345,578.417a.112.112,0,0,0-.125.1c-.014.1-1.4,10.295-2.558,29.259a.117.117,0,0,0,.1.128h.007a.115.115,0,0,0,.11-.112c1.159-18.953,2.542-29.139,2.556-29.239a.119.119,0,0,0-.093-.136",
    transform: "translate(-1298.972 -512.519)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138981",
    "data-name": "Path 138981",
    d: "M1401,405.924c-.159-.428-.3-.8-.438-1.146-.853-2.2-1.206-3.107-1.616-8.6a.114.114,0,0,0-.119-.11.117.117,0,0,0-.1.129c.413,5.536.8,6.521,1.633,8.678.133.343.278.716.437,1.142,1.159,3.111,5.8,11.919,5.844,12.007a.109.109,0,0,0,.1.06.1.1,0,0,0,.055-.016.126.126,0,0,0,.041-.163c-.047-.088-4.677-8.882-5.831-11.978",
    transform: "translate(-1251.599 -350.954)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44614",
    "data-name": "Group 44614",
    transform: "translate(162.127 59.145)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44613",
    "data-name": "Group 44613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44612",
    "data-name": "Group 44612",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44611",
    "data-name": "Group 44611",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44610",
    "data-name": "Group 44610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44609",
    "data-name": "Group 44609",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138982",
    "data-name": "Path 138982",
    d: "M1541.5,568l.44.038c1.6-21.8,8.358-48.468,8.426-48.735l-.426-.128c-.068.267-6.834,26.975-8.441,48.824",
    transform: "translate(-1541.498 -519.177)",
    fill: "#9ebee5"
  })))))))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138983",
    "data-name": "Path 138983",
    d: "M1389.385,520.739c-10.3,10.558-29.213-1.536-24.948,17.65,1.343-2.717,1.489-6.881,4.3-8.711a3.469,3.469,0,0,1,1.286-.508c7.358-1.315,17.75.619,21.195-10.494a14.838,14.838,0,0,1-1.829,2.062",
    transform: "translate(-1220.361 -459.59)",
    fill: "#fc4963"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138984",
    "data-name": "Path 138984",
    d: "M1604.565,514.636l.321,1.708.807.313,1.114-.673.146-1.836-1.178-.383Z",
    transform: "translate(-1435.813 -455.238)",
    fill: "#fc4963"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138985",
    "data-name": "Path 138985",
    d: "M1596.192,501.755l-2.05-1.165-.99,1.583,1.213,1.936,1.63-1.415.6,2.019,4.948-1.835-.262-1.536Z",
    transform: "translate(-1425.599 -443.564)",
    fill: "#9ebee5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138986",
    "data-name": "Path 138986",
    d: "M1446.122,901.27l-.12,1.521s3.148,3.541,13.043,5.3a74.626,74.626,0,0,0,17.222,1.163v-1.444s-21.682.418-30.145-6.537",
    transform: "translate(-1293.908 -798.57)",
    fill: "#21111d"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138987",
    "data-name": "Path 138987",
    d: "M1524.7,934.293l-3.944-.946a.279.279,0,0,0-.329.21l-.461,1.687a.307.307,0,0,0,.208.383l4,.968a.28.28,0,0,0,.333-.221l.4-1.708a.306.306,0,0,0-.211-.372",
    transform: "translate(-1360.095 -826.983)",
    fill: "#fec786"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138988",
    "data-name": "Path 138988",
    d: "M1387.474,228.881l-.084,0c-.047,0-4.679-.263-7.238.621a.122.122,0,0,0-.072.151.109.109,0,0,0,.139.078c2.331-.806,6.436-.645,7.075-.614l3.283,16.552a.113.113,0,0,0,.108.095l.023,0a.12.12,0,0,0,.085-.142Z",
    transform: "translate(-1234.906 -202.791)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138989",
    "data-name": "Path 138989",
    d: "M875.522,1325l-.585,4.107a42.864,42.864,0,0,0-.406,7.366l.3,9.677,5.251.269,4.084-40.128-10.411,1.492Z",
    transform: "translate(-781.778 -1157.417)",
    fill: "#fe9f73"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138990",
    "data-name": "Path 138990",
    d: "M721.728,1346.722l5.508-.577,5.127-21.158,4.17-17.208-10.092-1.492Z",
    transform: "translate(-645.721 -1157.417)",
    fill: "#fe9f73"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138991",
    "data-name": "Path 138991",
    d: "M678.079,1656.311H673.4l-1.9-2.242-3.469,2.242h-.747a.557.557,0,0,0-.542.463.567.567,0,0,0,.522.692h10.877a.151.151,0,0,0,.145-.157v-.769a.221.221,0,0,0-.211-.229",
    transform: "translate(-596.507 -1465.554)",
    fill: "#33182c"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138992",
    "data-name": "Path 138992",
    d: "M680.691,1648.289a2.538,2.538,0,0,1-3.414-.294l-3.972,1.912s-1.089.395-1.384,1.029h10.756v-2.084a1.6,1.6,0,0,0-1.987-.563",
    transform: "translate(-601.147 -1460.173)",
    fill: "#49263e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18711",
    "data-name": "Rectangle 18711",
    width: 0.08,
    height: 2.073,
    transform: "translate(81.492 188.679)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138993",
    "data-name": "Path 138993",
    d: "M737.582,1650.78l-.012.085a1.719,1.719,0,0,0,.247.015,2.774,2.774,0,0,0,1.648-.55l-.045-.071a2.642,2.642,0,0,1-1.838.521",
    transform: "translate(-659.899 -1462.178)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139230",
    "data-name": "Path 139230",
    d: "M0,.024.631,0l0,.084L0,.108Z",
    transform: "matrix(0.83, -0.558, 0.558, 0.83, 80.504, 190.284)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139231",
    "data-name": "Path 139231",
    d: "M0,.024.631,0l0,.084L0,.108Z",
    transform: "matrix(0.829, -0.559, 0.559, 0.829, 80.14, 190.179)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138994",
    "data-name": "Path 138994",
    d: "M677.685,1673.389H666.93a.6.6,0,0,0-.572.621.643.643,0,0,0,.2.474l.052-.066a.553.553,0,0,1-.174-.408.515.515,0,0,1,.493-.535h10.755a.238.238,0,0,1,.227.247v.576h.08v-.576a.321.321,0,0,0-.307-.333",
    transform: "translate(-596.168 -1482.672)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138995",
    "data-name": "Path 138995",
    d: "M672.5,1649.728a2.026,2.026,0,0,0-1.04.881l.072.037a1.993,1.993,0,0,1,1-.839c.8-.37,4.314-2.061,4.349-2.078l-.032-.079c-.035.017-3.549,1.708-4.348,2.078",
    transform: "translate(-600.735 -1459.867)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138996",
    "data-name": "Path 138996",
    d: "M892.166,1656.311h-.747l-3.469-2.242-1.9,2.242h-4.678a.221.221,0,0,0-.211.229v.769a.151.151,0,0,0,.145.157h10.877a.567.567,0,0,0,.522-.692.557.557,0,0,0-.542-.463",
    transform: "translate(-788.408 -1465.554)",
    fill: "#33182c"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138997",
    "data-name": "Path 138997",
    d: "M892.943,1649.908,888.971,1648a2.538,2.538,0,0,1-3.414.294,1.6,1.6,0,0,0-1.987.563v2.084h10.757c-.295-.634-1.384-1.029-1.384-1.029",
    transform: "translate(-790.561 -1460.173)",
    fill: "#49263e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18714",
    "data-name": "Rectangle 18714",
    width: 0.08,
    height: 2.073,
    transform: "translate(92.969 188.679)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138998",
    "data-name": "Path 138998",
    d: "M902.319,1650.258l-.045.071a2.775,2.775,0,0,0,1.649.551,1.69,1.69,0,0,0,.247-.015l-.012-.085a2.641,2.641,0,0,1-1.838-.521",
    transform: "translate(-807.3 -1462.178)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139232",
    "data-name": "Path 139232",
    d: "M.024,0,.108,0,.084.628,0,.631Z",
    transform: "matrix(0.559, -0.829, 0.829, 0.559, 93.452, 190.021)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139233",
    "data-name": "Path 139233",
    d: "M.024,0,.108,0,.084.628,0,.631Z",
    transform: "matrix(0.559, -0.829, 0.829, 0.559, 93.816, 189.916)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138999",
    "data-name": "Path 138999",
    d: "M891.846,1673.389H881.092a.321.321,0,0,0-.307.333v.576h.08v-.576a.238.238,0,0,1,.227-.247h10.755a.515.515,0,0,1,.493.535.554.554,0,0,1-.174.408l.051.066a.643.643,0,0,0,.2-.474.6.6,0,0,0-.572-.621",
    transform: "translate(-788.068 -1482.672)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139000",
    "data-name": "Path 139000",
    d: "M939.209,1649.728c-.8-.37-4.313-2.061-4.348-2.078l-.032.079c.035.017,3.55,1.708,4.349,2.078a1.991,1.991,0,0,1,1,.839l.072-.037a2.026,2.026,0,0,0-1.04-.881",
    transform: "translate(-836.435 -1459.867)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139001",
    "data-name": "Path 139001",
    d: "M705.4,1079.17a17.836,17.836,0,0,1-4.848-3.09c-1.006,2.047-3.51,6.728-3.5,7.795.05,3.688,3.7,10.167,5.4,11.863l2.456-3.09c-.683-1.265-2.614-7.864-2.123-8.7.473-.8,1.614-3.055,2.611-4.78",
    transform: "translate(-623.638 -953.452)",
    fill: "#fe9f73"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139002",
    "data-name": "Path 139002",
    d: "M944.214,850.507l-4.875,5.539,2.789,5.619,5.979-8.687,3.28-10.494-3.407-1.363Z",
    transform: "translate(-840.471 -745.277)",
    fill: "#fe9f73"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139003",
    "data-name": "Path 139003",
    d: "M1021.554,844.258l0-.163c-.039.086.023.271,0,.163",
    transform: "translate(-914.034 -747.912)",
    fill: "#fe9f73"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139004",
    "data-name": "Path 139004",
    d: "M1025.08,789.284c-.437-.286-.936-.663-1.335-.949a.09.09,0,0,1-.072-.016l-.086-.063a.1.1,0,0,1-.032-.042h0a.11.11,0,0,1,0-.091l.917-1.994a.462.462,0,0,0-.149-.577.383.383,0,0,0-.556.179s-1.549,2.959-1.826,3.4l-.425-1.156a.4.4,0,0,0-.465-.34.43.43,0,0,0-.314.5l.091,4.034c.016-.036.05-.056.115-.029,1.836,1.577,2.6.98,3.134,1.356l1.092-2.2a5.169,5.169,0,0,0,.572-1.372c-.027-.378-.352-.44-.662-.643",
    transform: "translate(-913.313 -695.991)",
    fill: "#fe9f73"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139005",
    "data-name": "Path 139005",
    d: "M1038.521,806.806a.423.423,0,0,0-.427-.1l-1.349,1.733a.493.493,0,0,0,.074.677.416.416,0,0,0,.593-.087l1.316-1.69a.6.6,0,0,0-.206-.534",
    transform: "translate(-927.553 -714.768)",
    fill: "#fe9f73"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139006",
    "data-name": "Path 139006",
    d: "M1044.945,812.112a.421.421,0,0,0-.429-.09l-1.318,1.761a.493.493,0,0,0,.085.675.417.417,0,0,0,.592-.1l1.286-1.717a.6.6,0,0,0-.215-.53",
    transform: "translate(-933.333 -719.474)",
    fill: "#fe9f73"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139007",
    "data-name": "Path 139007",
    d: "M1051.429,817.624a.392.392,0,0,0-.4-.079l-1.21,1.656a.458.458,0,0,0,.087.628.389.389,0,0,0,.55-.1l1.18-1.615a.559.559,0,0,0-.206-.491",
    transform: "translate(-939.267 -724.367)",
    fill: "#fe9f73"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139008",
    "data-name": "Path 139008",
    d: "M1037.969,808.224l-1.309,1.694a.339.339,0,0,1-.483.073.385.385,0,0,1-.14-.261.4.4,0,0,1,.08-.288l1.2-1.545a.093.093,0,0,0-.01-.124.077.077,0,0,0-.114.01l-1.2,1.545a.59.59,0,0,0-.117.422.561.561,0,0,0,.2.382.492.492,0,0,0,.7-.1l1.309-1.694a.1.1,0,0,0,.01-.016.093.093,0,0,0-.02-.108.076.076,0,0,0-.114.011",
    transform: "translate(-926.864 -715.712)",
    fill: "#f07162"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139009",
    "data-name": "Path 139009",
    d: "M1044.333,812.117l-1.231,1.692a.313.313,0,0,1-.459.083.381.381,0,0,1-.144-.258.4.4,0,0,1,.075-.29l1.318-1.761a.093.093,0,0,0-.012-.123.077.077,0,0,0-.114.013l-1.318,1.761a.591.591,0,0,0-.11.425.559.559,0,0,0,.211.377.467.467,0,0,0,.679-.116l1.232-1.693.008-.014a.093.093,0,0,0-.022-.11.077.077,0,0,0-.114.015",
    transform: "translate(-932.645 -718.979)",
    fill: "#f07162"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139010",
    "data-name": "Path 139010",
    d: "M1050.883,817.565l-1.18,1.615a.311.311,0,0,1-.441.082.349.349,0,0,1-.135-.235.364.364,0,0,1,.066-.267l1.21-1.656a.093.093,0,0,0-.013-.123.077.077,0,0,0-.114.014l-1.21,1.656a.558.558,0,0,0-.1.4.525.525,0,0,0,.2.353.464.464,0,0,0,.659-.117l1.18-1.615a.08.08,0,0,0,.008-.014.093.093,0,0,0-.021-.11.077.077,0,0,0-.114.014",
    transform: "translate(-938.578 -723.872)",
    fill: "#f07162"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139011",
    "data-name": "Path 139011",
    d: "M903.511,923.2c-1.7,1.382-8.627,8.546-9.235,8.786a1.147,1.147,0,0,1-.244.051l3.854,8.555c.206,0,3.625-4.986,9.673-14.372-1.506-2.641-2.4-3.233-4.048-3.02",
    transform: "translate(-799.924 -817.965)",
    fill: "#33182c"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139012",
    "data-name": "Path 139012",
    d: "M806.591,893.869c-.795-.458-2.322-.727-2.035-2.415a2.769,2.769,0,0,0-1.442-3.032c-1.965-1.221-2.006,1.267-2.686,1.581s-1.98.2-2.3,1.68.056,2.5-.661,2.814-2.929,2.663-2.013,5.259a2.975,2.975,0,0,0,3.3,2.144s9.472-.771,9.819-3.512-.689-3.776-1.982-4.521",
    transform: "translate(-711.505 -786.89)",
    fill: "#fecc86"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139013",
    "data-name": "Path 139013",
    d: "M837.2,926.6l1.414,7.489,2.969-.66-.431-2.283a1.22,1.22,0,0,0,.854-.652c.412-.934-.777-4.471-.777-4.471Z",
    transform: "translate(-749.058 -820.497)",
    fill: "#fe9f73"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139014",
    "data-name": "Path 139014",
    d: "M867.886,938.938a1,1,0,0,1,.007-.693.031.031,0,0,0-.014-.039.027.027,0,0,0-.036.015,1.052,1.052,0,0,0-.007.742.843.843,0,0,0,.553.455c-.017.083-.083.34-.25.419a.031.031,0,0,0-.014.039.027.027,0,0,0,.031.017l.006,0c.226-.107.284-.475.287-.49l0-.027-.024-.007a.8.8,0,0,1-.543-.43",
    transform: "translate(-776.42 -831.293)",
    fill: "#f07162"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139015",
    "data-name": "Path 139015",
    d: "M851.667,968.237a7.5,7.5,0,0,0,2.606,1.236l-.179-.926a5.507,5.507,0,0,1-2.427-.31",
    transform: "translate(-762.009 -857.903)",
    fill: "#f07162"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139016",
    "data-name": "Path 139016",
    d: "M853.568,936.514c-.739-.413-1.286.51-1.292.52a.063.063,0,0,0,.017.083.051.051,0,0,0,.041.008.056.056,0,0,0,.036-.027c.02-.034.5-.84,1.148-.477a.053.053,0,0,0,.074-.026.063.063,0,0,0-.024-.081",
    transform: "translate(-762.547 -829.702)",
    fill: "#33192c"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139017",
    "data-name": "Path 139017",
    d: "M870.307,930.689c-.359-.216-.756.338-.773.361a.063.063,0,0,0,.01.084.052.052,0,0,0,.045.011.055.055,0,0,0,.033-.022c0-.005.356-.5.632-.329a.053.053,0,0,0,.075-.023.063.063,0,0,0-.021-.081",
    transform: "translate(-777.989 -824.591)",
    fill: "#33192c"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139018",
    "data-name": "Path 139018",
    d: "M874.5,939.522a.167.167,0,0,0-.12.2.154.154,0,0,0,.182.13.167.167,0,0,0,.12-.2.155.155,0,0,0-.182-.13",
    transform: "translate(-782.333 -832.458)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139019",
    "data-name": "Path 139019",
    d: "M859.81,942.531a.167.167,0,0,0-.12.2.155.155,0,0,0,.182.13.167.167,0,0,0,.12-.2.155.155,0,0,0-.182-.13",
    transform: "translate(-769.187 -835.124)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139020",
    "data-name": "Path 139020",
    d: "M832.029,946.624a.937.937,0,0,0-.672,1.1.867.867,0,0,0,1.018.729.937.937,0,0,0,.672-1.1.867.867,0,0,0-1.018-.729",
    transform: "translate(-743.817 -838.736)",
    fill: "#fe9f73"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139021",
    "data-name": "Path 139021",
    d: "M835.477,951.069a.545.545,0,0,0-.421.062.031.031,0,0,0-.01.041.026.026,0,0,0,.038.011.5.5,0,0,1,.377-.057.389.389,0,0,1,.205.176.382.382,0,0,0-.44.087.393.393,0,0,0-.055.453.357.357,0,0,0,.389.215h.005a.03.03,0,0,0,.021-.036.028.028,0,0,0-.033-.023.3.3,0,0,1-.334-.183.335.335,0,0,1,.044-.382.349.349,0,0,1,.454-.038l.083.059-.043-.1a.487.487,0,0,0-.281-.288",
    transform: "translate(-747.131 -842.673)",
    fill: "#f07162"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139022",
    "data-name": "Path 139022",
    d: "M838.931,915.966a1.763,1.763,0,0,0-1.736,1.7l2.068,0,1.831-.554.13-.019a2.045,2.045,0,0,0-2.292-1.122",
    transform: "translate(-749.057 -811.567)",
    fill: "#fe9f73"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139023",
    "data-name": "Path 139023",
    d: "M833.044,908.175c-.12.027-1.861,1.288-1.861,1.288s-.066,2.7.966,2.561,1.149-2.105,1.149-2.105a3.191,3.191,0,0,0,2.318-1.442l-.462-.908s-1.99.578-2.11.6",
    transform: "translate(-743.676 -804.152)",
    fill: "#fecc86"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139024",
    "data-name": "Path 139024",
    d: "M865.662,947.117c-.043.01-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-774.511 -839.19)",
    fill: "#ea5942"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139025",
    "data-name": "Path 139025",
    d: "M863.959,948.663c-.043.01-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-772.986 -840.559)",
    fill: "#ea5942"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139026",
    "data-name": "Path 139026",
    d: "M859.971,947.086c-.043.009-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-769.417 -839.162)",
    fill: "#ea5942"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139027",
    "data-name": "Path 139027",
    d: "M857.426,950c-.043.01-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-767.14 -841.745)",
    fill: "#ea5942"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139028",
    "data-name": "Path 139028",
    d: "M853.635,947.562c-.043.01-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-763.747 -839.584)",
    fill: "#ea5942"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139029",
    "data-name": "Path 139029",
    d: "M853.428,952.391c-.043.01-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-763.562 -843.863)",
    fill: "#ea5942"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139030",
    "data-name": "Path 139030",
    d: "M871.668,943.941c-.043.01-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-779.886 -836.376)",
    fill: "#ea5942"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139031",
    "data-name": "Path 139031",
    d: "M874.566,946.04c-.043.01-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-782.479 -838.235)",
    fill: "#ea5942"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139032",
    "data-name": "Path 139032",
    d: "M877.2,944.3c-.043.01-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-784.838 -836.697)",
    fill: "#ea5942"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139033",
    "data-name": "Path 139033",
    d: "M878.344,948.782c-.043.01-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-785.86 -840.665)",
    fill: "#ea5942"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139034",
    "data-name": "Path 139034",
    d: "M879.954,945.685c-.043.01-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-787.301 -837.921)",
    fill: "#ea5942"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139035",
    "data-name": "Path 139035",
    d: "M878.642,941.839c-.043.01-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-786.127 -834.513)",
    fill: "#ea5942"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139036",
    "data-name": "Path 139036",
    d: "M862.073,951.143c-.043.01-.029.082.014.073s.029-.082-.014-.073",
    transform: "translate(-771.299 -842.757)",
    fill: "#ea5942"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139037",
    "data-name": "Path 139037",
    d: "M723.358,1005.5c.083-.441.141-6.549.6-6.856a5.089,5.089,0,0,0,.312-4.2c-.368-.9-3.066-5.416-3.432-5.893h0a28.157,28.157,0,0,0-6.076-.257c-1.838-.189-5.538.175-7.353,1.531-2.061,2.183-5.972,8.669-8.912,14.492a46.851,46.851,0,0,0,5.506,2.157l3.885-7.175c.879,2.731,2.026,5.66,2.074,6,.037.262-.312.546-.45.891-.109.274-.992,1.857-1.787,3.678-.906,2.076-1.744,4.435-1.976,5.018a89.7,89.7,0,0,0-5.064,20.46s14.8,8.361,27.727,1.125c.063-.369,1.428-17.886-5.054-30.977",
    transform: "translate(-624.93 -875.637)",
    fill: "#49263e"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139038",
    "data-name": "Path 139038",
    d: "M795.32,999.667a3.467,3.467,0,0,0-1.549,1.193.067.067,0,0,0,.012.089.054.054,0,0,0,.035.013.057.057,0,0,0,.047-.025,3.412,3.412,0,0,1,1.491-1.148.065.065,0,0,0,.038-.08.058.058,0,0,0-.073-.041",
    transform: "translate(-710.186 -885.747)",
    fill: "#21111d"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139039",
    "data-name": "Path 139039",
    d: "M796.365,1004.8a3.468,3.468,0,0,0-1.549,1.193.067.067,0,0,0,.012.089.055.055,0,0,0,.035.013.056.056,0,0,0,.047-.025,3.411,3.411,0,0,1,1.491-1.148.065.065,0,0,0,.037-.08.058.058,0,0,0-.073-.041",
    transform: "translate(-711.121 -890.295)",
    fill: "#21111d"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139040",
    "data-name": "Path 139040",
    d: "M808.755,1137.571l-1.506-.173a.071.071,0,0,0-.077.067.074.074,0,0,0,.062.083l1.506.173h.007a.072.072,0,0,0,.069-.067.074.074,0,0,0-.062-.083",
    transform: "translate(-722.189 -1007.78)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139041",
    "data-name": "Path 139041",
    d: "M934.621,1041.37l.446-6.552a5.163,5.163,0,0,0-.432-6.041.066.066,0,0,0-.1,0,.08.08,0,0,0,0,.107,5.005,5.005,0,0,1,.405,5.868l-.01.016-.45,6.615,0,.025.012.021a35.589,35.589,0,0,1,2.96,7.849,72.814,72.814,0,0,1,2.087,23.084.074.074,0,0,0,.065.08h0a.072.072,0,0,0,.069-.071,72.963,72.963,0,0,0-2.095-23.144,36.267,36.267,0,0,0-2.962-7.858",
    transform: "translate(-836.122 -911.522)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139042",
    "data-name": "Path 139042",
    d: "M868.989,956.637c.314-.075.353-.479.353-.479s-.846.2-.859.2.191.349.505.274",
    transform: "translate(-777.059 -847.201)",
    fill: "#fbfdfc"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139043",
    "data-name": "Path 139043",
    d: "M733.5,1100.023l1.455,4.22c-.359.622-5.664,10.016-8.468,25.391a.075.075,0,0,0,.055.089l.014,0a.072.072,0,0,0,.068-.061c2.882-15.807,8.411-25.277,8.467-25.371l.019-.032-1.5-4.359Z",
    transform: "translate(-649.976 -974.558)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139044",
    "data-name": "Path 139044",
    d: "M776.924,1214.649a7.182,7.182,0,0,1-1.266.579l1.019.822a8.972,8.972,0,0,0,.763-.967c.105-.223.08-.792-.517-.434",
    transform: "translate(-693.985 -1076.123)",
    fill: "#f07162"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139045",
    "data-name": "Path 139045",
    d: "M755.874,1217.025a6.82,6.82,0,0,0-2.6-1.5c-.277-.04-1.4-.213-2.373-.361-.01-.018-.321-.612-.331-.632l-2.117,3.875,1.16.387a42.723,42.723,0,0,1,4.628,1.241h0c.506.312.993.6,1.215.731a.4.4,0,0,0,.389.019c.169-.086.3-.305-.072-.864,0,0,.931-.014.156-.969,0,0,.955.186.183-.953,0,0,.593.036-.238-.976",
    transform: "translate(-669.639 -1076.124)",
    fill: "#fe9f73"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139046",
    "data-name": "Path 139046",
    d: "M808.158,1254.1a.061.061,0,0,0-.018-.007.06.06,0,0,0-.066.032.07.07,0,0,0,.023.091,7.7,7.7,0,0,1,.985.8.058.058,0,0,0,.087-.005.071.071,0,0,0-.005-.095,7.68,7.68,0,0,0-1.006-.821",
    transform: "translate(-722.988 -1111.167)",
    fill: "#f07162"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139047",
    "data-name": "Path 139047",
    d: "M809.666,1246.8l-.011,0a.061.061,0,0,0-.07.04.069.069,0,0,0,.034.088,3.816,3.816,0,0,1,.974.662.058.058,0,0,0,.087,0,.071.071,0,0,0,0-.095,3.87,3.87,0,0,0-1.01-.687",
    transform: "translate(-724.345 -1104.711)",
    fill: "#f07162"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139048",
    "data-name": "Path 139048",
    d: "M812.673,1238.763l-.013,0a.061.061,0,0,0-.069.038.069.069,0,0,0,.031.088,3.312,3.312,0,0,1,.841.625.058.058,0,0,0,.087,0,.071.071,0,0,0,0-.095,3.391,3.391,0,0,0-.877-.652",
    transform: "translate(-727.034 -1097.586)",
    fill: "#f07162"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139049",
    "data-name": "Path 139049",
    d: "M701.295,1124.817c.053-.932-2.515-1.985-2.515-1.985l-2.94.728a6.288,6.288,0,0,0-.152,3.448c.434,2.031,2.235,7.4,4.847,9.812a23.892,23.892,0,0,0,2.736-3.969s-2.03-7.1-1.977-8.033",
    transform: "translate(-622.274 -994.875)",
    fill: "#49263e"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139050",
    "data-name": "Path 139050",
    d: "M984.263,851.982l.447,3.225s2.81,1.021,3.6-.2,3.28-10.358,3.28-10.358a6.309,6.309,0,0,0-3.728-1.864Z",
    transform: "translate(-880.676 -746.747)",
    fill: "#33182c"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139051",
    "data-name": "Path 139051",
    d: "M831.339,987.083s6.4,8.081,6.829,9.078c0,0,.4-6.909.38-9.009a24.609,24.609,0,0,0-7.21-.068",
    transform: "translate(-743.817 -874.41)",
    fill: "#fff"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139052",
    "data-name": "Path 139052",
    d: "M845.31,980.4l-2.348-.607-.518,1.231,2.7.817.237-.73.428.456.855-1.015-.633-.881Z",
    transform: "translate(-753.756 -868.034)",
    fill: "#9ebee5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139053",
    "data-name": "Path 139053",
    d: "M831.339,988.758a31.464,31.464,0,0,0,1.261,4l1.811.97-.033,1.532,3.791,2.58s-4.583-6.867-6.829-9.077",
    transform: "translate(-743.817 -876.085)",
    fill: "#33182c"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139054",
    "data-name": "Path 139054",
    d: "M896.727,989.357c-.312,2.075-.38,9.009-.38,9.009l1.351-3.7-.485-.836.615-1.414c-.047-.383-1.1-3.057-1.1-3.057",
    transform: "translate(-801.996 -876.615)",
    fill: "#33182c"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139055",
    "data-name": "Path 139055",
    d: "M794.759,1192.447l-2.142,3.141-11.437-4.346,11.473,5.8,2.107-2.912,2.095,2.527,3.1-4.483-3.172,3.238Z",
    transform: "translate(-698.927 -1055.487)",
    fill: "#33182c"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139056",
    "data-name": "Path 139056",
    d: "M895.81,998.311h.113c0-.058.049-5.895.38-9l-.112-.014c-.332,3.115-.381,8.957-.381,9.016",
    transform: "translate(-801.515 -876.56)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139057",
    "data-name": "Path 139057",
    d: "M912.087,1202.233l-1.986-2.912-.091.073,2.062,3.022,3.218-3.285-.077-.089Z",
    transform: "translate(-814.223 -1062.398)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139058",
    "data-name": "Path 139058",
    d: "M860.768,1082.123l.061-.764-9.162.641Z",
    transform: "translate(-762.009 -958.129)",
    fill: "#33182c"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139059",
    "data-name": "Path 139059",
    d: "M793.174,997.455l-.009-.013c-.046-.07-4.659-7.024-6.838-9.088l-.074.092c2.124,2.012,6.584,8.711,6.812,9.054l1.477,15.169-2.1,3.086-11.4-4.331-.037.115,11.438,4.345.039.015,2.18-3.2-1.483-15.232Z",
    transform: "translate(-698.768 -875.727)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139060",
    "data-name": "Path 139060",
    d: "M2256.887,904.521c-1.031,1.451-1.136,7.071-1.136,7.071l.5.03c.034-.182.175-.7.175-.7l.116.719,1.958.117,1.516-8.448a3.64,3.64,0,0,0-3.133,1.212",
    transform: "translate(-2018.59 -800.364)",
    fill: "#49263e"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139061",
    "data-name": "Path 139061",
    d: "M2272.832,907.523c-.206,0-.4.012-.406.048a15,15,0,0,1-1.367.723l-.261.13-.418.207-.11.054h0c-.667.33-1.23.6-1.23.6s-1.744,4.01.254,5l-.132.9-.041.276-.051.344-.206,1.4-.005.036.034,0,.745-.048h.019l2.216-.142.164-1.078c-.141-.011-.223-.02-.223-.02l.008-.027.231-.06.251-1.652.025-.163.182-1.2.132-.87.01-.068.029-.187.1-.636.541-3.564s-.25-.011-.486-.01",
    transform: "translate(-2029.85 -804.11)",
    fill: "#fe9f73"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139062",
    "data-name": "Path 139062",
    d: "M2277.646,934.656a.03.03,0,0,0-.012.039.98.98,0,0,1,.031.676.789.789,0,0,1-.515.442l-.023.008,0,.026c0,.015.073.371.3.467l.006,0a.027.027,0,0,0,.03-.018.031.031,0,0,0-.015-.038c-.166-.07-.239-.319-.259-.4a.832.832,0,0,0,.525-.466,1.03,1.03,0,0,0-.033-.724.026.026,0,0,0-.036-.013",
    transform: "translate(-2037.72 -828.147)",
    fill: "#f07162"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139063",
    "data-name": "Path 139063",
    d: "M2276.291,964.721l-.137.9a6.912,6.912,0,0,0,2.511-1.177,5.378,5.378,0,0,1-2.374.274",
    transform: "translate(-2036.849 -854.545)",
    fill: "#f07162"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139064",
    "data-name": "Path 139064",
    d: "M2288.408,938.1a.152.152,0,0,0-.172.134.162.162,0,0,0,.124.187.152.152,0,0,0,.173-.134.162.162,0,0,0-.124-.187",
    transform: "translate(-2047.66 -831.199)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139065",
    "data-name": "Path 139065",
    d: "M2274.063,936.209a.152.152,0,0,0-.172.134.162.162,0,0,0,.124.187.152.152,0,0,0,.172-.134.161.161,0,0,0-.124-.187",
    transform: "translate(-2034.822 -829.524)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139066",
    "data-name": "Path 139066",
    d: "M2281.905,950.974c.379-.1.415-.593.415-.593-.017,0-1.037.278-1.037.278s.243.417.622.315",
    transform: "translate(-2041.44 -842.082)",
    fill: "#fbfdfc"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139067",
    "data-name": "Path 139067",
    d: "M2289.735,903.671a2.423,2.423,0,0,0-.443-.243l-.013-.005a3.286,3.286,0,0,0-1.642-.235c-.546.078-.96.346-.959.858a4.084,4.084,0,0,0,.113.7c0,.007,0,.015.006.023.016.066.034.135.056.207a4.638,4.638,0,0,0,.365.893,3.571,3.571,0,0,0,1.138,1.277,1.8,1.8,0,0,1,.345.3c.03.034.059.069.086.105a1.618,1.618,0,0,1,.234.444c.009.026.017.051.024.077s.01.034.014.051a2.34,2.34,0,0,1,.035.922,4.289,4.289,0,0,1-.349,1.145c-.084.185-.151.3-.162.322l.138-.159,1.884-2.18s.484-3.548-.868-4.5",
    transform: "translate(-2046.268 -800.248)",
    fill: "#49263e"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139068",
    "data-name": "Path 139068",
    d: "M2286.733,931.883a.058.058,0,0,0-.043.067.054.054,0,0,0,.062.047.981.981,0,0,1,.75.238.05.05,0,0,0,.048.012.052.052,0,0,0,.027-.019.061.061,0,0,0-.006-.082,1.066,1.066,0,0,0-.837-.263",
    transform: "translate(-2046.278 -825.681)",
    fill: "#49263e"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139069",
    "data-name": "Path 139069",
    d: "M2273.328,931.044a1.05,1.05,0,0,0-.861.141.061.061,0,0,0-.016.08.053.053,0,0,0,.043.027.049.049,0,0,0,.031-.009.962.962,0,0,1,.771-.128.053.053,0,0,0,.067-.038.059.059,0,0,0-.035-.073",
    transform: "translate(-2033.528 -824.911)",
    fill: "#49263e"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139070",
    "data-name": "Path 139070",
    d: "M2286.927,913.151l.665-.761-.83.608Z",
    transform: "translate(-2046.342 -808.422)",
    fill: "#fe9f73"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139071",
    "data-name": "Path 139071",
    d: "M2292.066,920.516a2.222,2.222,0,0,1-1.092-1.532.071.071,0,0,0-.08-.063.075.075,0,0,0-.058.087,2.344,2.344,0,0,0,1.172,1.645l0,0a.068.068,0,0,0,.088-.039.078.078,0,0,0-.034-.1",
    transform: "translate(-2049.988 -814.208)",
    fill: "#21111d"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139072",
    "data-name": "Path 139072",
    d: "M2303.021,905.685a2.4,2.4,0,0,0-.442-.243l-.013,0-.03.238-.472,3.688s0,.012,0,.035,0,.09.007.169c.007.248.01.711-.033,1.339a18.7,18.7,0,0,1-.4,2.733l-.114.442.231-.06.251-1.652,1.884-2.18s.484-3.548-.869-4.5",
    transform: "translate(-2059.554 -802.262)",
    fill: "#49263e"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139073",
    "data-name": "Path 139073",
    d: "M2304.035,938.872a.853.853,0,0,0-.968.753.909.909,0,0,0,.694,1.05.853.853,0,0,0,.968-.753.908.908,0,0,0-.694-1.05",
    transform: "translate(-2060.926 -831.875)",
    fill: "#fe9f73"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139074",
    "data-name": "Path 139074",
    d: "M2309.138,943.208a.534.534,0,0,0-.413-.043.479.479,0,0,0-.264.293l-.039.1.079-.061a.341.341,0,0,1,.444.018.326.326,0,0,1,.056.371.3.3,0,0,1-.319.192.027.027,0,0,0-.031.024.029.029,0,0,0,.021.034h0a.351.351,0,0,0,.373-.225.384.384,0,0,0-.069-.44.372.372,0,0,0-.433-.067.381.381,0,0,1,.194-.18.486.486,0,0,1,.37.04.026.026,0,0,0,.036-.012.031.031,0,0,0-.011-.04",
    transform: "translate(-2065.729 -835.665)",
    fill: "#f07162"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139075",
    "data-name": "Path 139075",
    d: "M2457.219,1203.436l1.119.037a.389.389,0,0,0,.462-.32.422.422,0,0,0-.294-.5l-2.356-.888c-.136-.033-.372.129-.533.309a31,31,0,0,0-2.834,1.738l1.382,2.186a6.585,6.585,0,0,1,.855,2.079l.042.187a.385.385,0,0,0,.492.3.437.437,0,0,0,.257-.514l-.3-1.354a.107.107,0,0,1,.041-.11.092.092,0,0,1,.138.049l.688,1.917a.3.3,0,0,0,.476.169.57.57,0,0,0,.189-.63l-.7-1.955a.107.107,0,0,1,.037-.123l.027-.019a.09.09,0,0,1,.13.031l1.153,1.962a.379.379,0,0,0,.52.155.44.44,0,0,0,.141-.594l-1.16-1.974a.107.107,0,0,1,.029-.141l.085-.059a.089.089,0,0,1,.123.02l1.288,1.667a.375.375,0,0,0,.534.08.445.445,0,0,0,.068-.61s-1.839-2.656-2.095-3.1",
    transform: "translate(-2194.923 -1064.806)",
    fill: "#fe9f73"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139076",
    "data-name": "Path 139076",
    d: "M2100.664,841.067l-3.407,1.363,3.28,10.494,5.979,8.687,2.79-5.619-4.875-5.539Z",
    transform: "translate(-1876.746 -745.229)",
    fill: "#fe9f73"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139077",
    "data-name": "Path 139077",
    d: "M2129.553,844.041l0,.164c-.02.107.043-.077,0-.164",
    transform: "translate(-1905.643 -747.864)",
    fill: "#fe9f73"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139078",
    "data-name": "Path 139078",
    d: "M2087.535,787.58a.4.4,0,0,0-.465.34l-.425,1.156c-.277-.441-1.826-3.4-1.826-3.4a.382.382,0,0,0-.555-.179.462.462,0,0,0-.149.577l.917,1.994a.11.11,0,0,1,0,.091.1.1,0,0,1-.032.042l-.085.063a.089.089,0,0,1-.072.016c-.4.286-.9.663-1.335.949-.311.2-.635.265-.662.643a5.166,5.166,0,0,0,.571,1.372l1.092,2.2c.531-.376,1.3.221,3.134-1.356.066-.027.1-.007.115.029l.091-4.034a.43.43,0,0,0-.314-.5",
    transform: "translate(-1863.849 -695.942)",
    fill: "#fe9f73"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139079",
    "data-name": "Path 139079",
    d: "M2095.32,806.652a.422.422,0,0,0-.427.1.6.6,0,0,0-.206.534l1.315,1.69a.417.417,0,0,0,.593.087.493.493,0,0,0,.074-.677Z",
    transform: "translate(-1874.434 -714.719)",
    fill: "#fe9f73"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139080",
    "data-name": "Path 139080",
    d: "M2089.121,811.968a.423.423,0,0,0-.429.09.6.6,0,0,0-.215.53l1.285,1.717a.417.417,0,0,0,.591.1.492.492,0,0,0,.086-.675Z",
    transform: "translate(-1868.877 -719.426)",
    fill: "#fe9f73"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139081",
    "data-name": "Path 139081",
    d: "M2083.946,817.49a.393.393,0,0,0-.4.079.56.56,0,0,0-.206.491l1.18,1.615a.389.389,0,0,0,.55.1.458.458,0,0,0,.086-.628Z",
    transform: "translate(-1864.281 -724.319)",
    fill: "#fe9f73"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139082",
    "data-name": "Path 139082",
    d: "M2095.01,807.729a.077.077,0,0,0-.114-.01.093.093,0,0,0-.01.124l1.2,1.545a.4.4,0,0,1,.08.289.383.383,0,0,1-.14.261.339.339,0,0,1-.483-.073l-1.309-1.694a.076.076,0,0,0-.114-.011.093.093,0,0,0-.02.108.119.119,0,0,0,.01.016l1.31,1.694a.492.492,0,0,0,.7.1.561.561,0,0,0,.2-.382.588.588,0,0,0-.117-.422Z",
    transform: "translate(-1873.916 -715.664)",
    fill: "#f07162"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139083",
    "data-name": "Path 139083",
    d: "M2089.249,811.418a.077.077,0,0,0-.114-.013.092.092,0,0,0-.012.123l1.318,1.761a.4.4,0,0,1,.075.29.38.38,0,0,1-.145.258.313.313,0,0,1-.459-.083l-1.231-1.692a.077.077,0,0,0-.114-.015.093.093,0,0,0-.021.11.057.057,0,0,0,.008.013l1.232,1.693a.467.467,0,0,0,.679.116.558.558,0,0,0,.211-.377.59.59,0,0,0-.11-.425Z",
    transform: "translate(-1868.943 -718.931)",
    fill: "#f07162"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139084",
    "data-name": "Path 139084",
    d: "M2083.413,816.942a.077.077,0,0,0-.114-.014.093.093,0,0,0-.013.123l1.21,1.656a.365.365,0,0,1,.066.267.35.35,0,0,1-.135.235.311.311,0,0,1-.44-.082l-1.18-1.615a.077.077,0,0,0-.114-.014.092.092,0,0,0-.021.11.083.083,0,0,0,.008.014l1.18,1.615a.464.464,0,0,0,.659.117.523.523,0,0,0,.2-.353.558.558,0,0,0-.1-.4Z",
    transform: "translate(-1863.685 -723.824)",
    fill: "#f07162"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139085",
    "data-name": "Path 139085",
    d: "M2132.531,923.145c-1.647-.212-2.542.379-4.048,3.02,6.049,9.386,9.467,14.372,9.673,14.372l3.854-8.555a1.157,1.157,0,0,1-.244-.051c-.607-.24-7.533-7.4-9.235-8.786",
    transform: "translate(-1904.692 -817.916)",
    fill: "#33182c"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139086",
    "data-name": "Path 139086",
    d: "M2097.257,844.589s2.489,9.132,3.28,10.358,3.6.2,3.6.2l.447-3.225-3.6-9.2a6.309,6.309,0,0,0-3.728,1.864",
    transform: "translate(-1876.746 -746.699)",
    fill: "#33182c"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139087",
    "data-name": "Path 139087",
    d: "M2173.683,1306.233l4.084,40.128,5.251-.269.3-9.677a42.837,42.837,0,0,0-.406-7.365l-.584-4.107,1.766-17.217Z",
    transform: "translate(-1945.144 -1157.369)",
    fill: "#fe9f73"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139088",
    "data-name": "Path 139088",
    d: "M2283.884,1307.724l9.3,38.366,5.508.577-4.714-40.436Z",
    transform: "translate(-2043.767 -1157.369)",
    fill: "#fe9f73"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139089",
    "data-name": "Path 139089",
    d: "M2187.584,989.776c-1.815-1.355-5.516-1.72-7.353-1.531a28.15,28.15,0,0,0-6.076.258h0c-.365.477-3.064,5-3.432,5.893a5.088,5.088,0,0,0,.312,4.2c.458.307.517,6.415.6,6.856-6.47,13.068-5.13,30.611-5.066,30.989,12.924,7.235,27.739-1.136,27.739-1.136a89.693,89.693,0,0,0-5.064-20.46c-.232-.584-1.07-2.942-1.976-5.019-.795-1.821-1.677-3.4-1.787-3.678-.138-.345-.487-.629-.45-.891.049-.345,1.2-3.274,2.074-6.005l3.885,7.176,5.373,8.5,4.51-2.23-4.719-9.094c-2.9-5.642-6.589-11.722-8.572-13.822",
    transform: "translate(-1938.637 -875.589)",
    fill: "#49263e"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139090",
    "data-name": "Path 139090",
    d: "M2342.021,999.613a.058.058,0,0,0-.074.041.065.065,0,0,0,.038.08,3.413,3.413,0,0,1,1.491,1.148.056.056,0,0,0,.047.025.056.056,0,0,0,.035-.013.067.067,0,0,0,.012-.089,3.469,3.469,0,0,0-1.548-1.192",
    transform: "translate(-2095.728 -885.699)",
    fill: "#21111d"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139091",
    "data-name": "Path 139091",
    d: "M2340.975,1004.746a.057.057,0,0,0-.073.041.064.064,0,0,0,.038.079,3.411,3.411,0,0,1,1.491,1.148.057.057,0,0,0,.047.025.054.054,0,0,0,.034-.013.066.066,0,0,0,.012-.089,3.464,3.464,0,0,0-1.548-1.192",
    transform: "translate(-2094.793 -890.247)",
    fill: "#21111d"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139092",
    "data-name": "Path 139092",
    d: "M2330.016,1137.343l-1.505.173a.075.075,0,0,0-.062.083.072.072,0,0,0,.07.068h.007l1.506-.173a.074.074,0,0,0,.062-.083.07.07,0,0,0-.077-.067",
    transform: "translate(-2083.65 -1007.731)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139093",
    "data-name": "Path 139093",
    d: "M2170.841,1034.713l-.01-.016a5.006,5.006,0,0,1,.405-5.868.08.08,0,0,0,0-.107.066.066,0,0,0-.1,0,5.163,5.163,0,0,0-.432,6.041l.446,6.552a36.282,36.282,0,0,0-2.962,7.858,72.97,72.97,0,0,0-2.095,23.144.072.072,0,0,0,.069.071h0a.074.074,0,0,0,.065-.08,72.819,72.819,0,0,1,2.087-23.084,35.6,35.6,0,0,1,2.96-7.849l.012-.021,0-.025Z",
    transform: "translate(-1938.224 -911.474)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139094",
    "data-name": "Path 139094",
    d: "M2380.828,1656.257h-.747l-3.469-2.242-1.9,2.242h-4.678a.221.221,0,0,0-.211.229v.769a.151.151,0,0,0,.145.157h10.877a.566.566,0,0,0,.522-.692.556.556,0,0,0-.542-.463",
    transform: "translate(-2120.681 -1465.506)",
    fill: "#33182c"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139095",
    "data-name": "Path 139095",
    d: "M2381.6,1649.854l-3.972-1.912a2.539,2.539,0,0,1-3.414.294,1.6,1.6,0,0,0-1.988.563v2.084h10.757c-.295-.634-1.384-1.029-1.384-1.029",
    transform: "translate(-2122.833 -1460.125)",
    fill: "#49263e"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18717",
    "data-name": "Rectangle 18717",
    width: 0.08,
    height: 2.073,
    transform: "translate(249.358 188.673)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139096",
    "data-name": "Path 139096",
    d: "M2390.98,1650.2l-.045.071a2.773,2.773,0,0,0,1.649.55,1.778,1.778,0,0,0,.247-.015l-.012-.085a2.644,2.644,0,0,1-1.838-.522",
    transform: "translate(-2139.572 -1462.13)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139234",
    "data-name": "Path 139234",
    d: "M.024,0,.108,0,.084.628,0,.631Z",
    transform: "translate(249.841 190.015) rotate(-56.009)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139235",
    "data-name": "Path 139235",
    d: "M.024,0,.108,0,.084.628,0,.631Z",
    transform: "translate(250.205 189.91) rotate(-56.009)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139097",
    "data-name": "Path 139097",
    d: "M2380.509,1673.335h-10.755a.321.321,0,0,0-.307.333v.576h.08v-.576a.238.238,0,0,1,.227-.246h10.755a.515.515,0,0,1,.493.534.555.555,0,0,1-.174.408l.052.066a.642.642,0,0,0,.2-.473.6.6,0,0,0-.572-.621",
    transform: "translate(-2120.342 -1482.624)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139098",
    "data-name": "Path 139098",
    d: "M2427.871,1649.673c-.8-.37-4.312-2.061-4.348-2.078l-.033.079c.036.017,3.55,1.708,4.349,2.078a1.989,1.989,0,0,1,1,.839l.072-.037a2.028,2.028,0,0,0-1.04-.881",
    transform: "translate(-2168.708 -1459.818)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139099",
    "data-name": "Path 139099",
    d: "M2166.741,1656.257h-4.678l-1.9-2.242-3.469,2.242h-.747a.556.556,0,0,0-.542.463.567.567,0,0,0,.522.692h10.877a.151.151,0,0,0,.145-.157v-.769a.221.221,0,0,0-.211-.229",
    transform: "translate(-1928.779 -1465.506)",
    fill: "#33182c"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139100",
    "data-name": "Path 139100",
    d: "M2169.353,1648.234a2.538,2.538,0,0,1-3.413-.293l-3.972,1.912s-1.089.4-1.384,1.029h10.757V1648.8a1.6,1.6,0,0,0-1.988-.563",
    transform: "translate(-1933.421 -1460.125)",
    fill: "#49263e"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18720",
    "data-name": "Rectangle 18720",
    width: 0.08,
    height: 2.073,
    transform: "translate(237.88 188.673)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139101",
    "data-name": "Path 139101",
    d: "M2226.245,1650.726l-.012.085a1.789,1.789,0,0,0,.247.014,2.774,2.774,0,0,0,1.648-.55l-.045-.071a2.644,2.644,0,0,1-1.838.522",
    transform: "translate(-1992.173 -1462.13)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139236",
    "data-name": "Path 139236",
    d: "M0,.024.631,0l0,.084L0,.108Z",
    transform: "matrix(0.83, -0.558, 0.558, 0.83, 236.893, 190.277)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139237",
    "data-name": "Path 139237",
    d: "M0,.024.631,0l0,.084L0,.108Z",
    transform: "matrix(0.829, -0.559, 0.559, 0.829, 236.529, 190.173)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139102",
    "data-name": "Path 139102",
    d: "M2166.346,1673.335h-10.755a.6.6,0,0,0-.572.621.643.643,0,0,0,.2.473l.051-.066a.554.554,0,0,1-.174-.408.515.515,0,0,1,.493-.534h10.755a.238.238,0,0,1,.227.246v.576h.08v-.576a.321.321,0,0,0-.307-.333",
    transform: "translate(-1928.44 -1482.624)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139103",
    "data-name": "Path 139103",
    d: "M2161.163,1649.673a2.025,2.025,0,0,0-1.04.881l.072.037a1.992,1.992,0,0,1,1-.839c.8-.37,4.313-2.061,4.349-2.078l-.032-.079c-.035.017-3.549,1.708-4.348,2.078",
    transform: "translate(-1933.008 -1459.818)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139104",
    "data-name": "Path 139104",
    d: "M2344.317,1099.969l-.106-.121-1.5,4.359.019.032c.055.094,5.585,9.564,8.467,25.371a.071.071,0,0,0,.068.061h.014a.075.075,0,0,0,.055-.089c-2.8-15.375-8.109-24.769-8.468-25.391Z",
    transform: "translate(-2096.412 -974.51)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139105",
    "data-name": "Path 139105",
    d: "M2251.307,987.1c-.018,2.1.38,9.009.38,9.009.433-1,6.829-9.077,6.829-9.077a24.6,24.6,0,0,0-7.209.068",
    transform: "translate(-2014.612 -874.362)",
    fill: "#fff"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139106",
    "data-name": "Path 139106",
    d: "M2302.516,905.48a2.423,2.423,0,0,1,.442.243c1.353.955.869,4.5.869,4.5l-1.884,2.18-.251,1.652-.231.06-.008.027s.082.009.223.02l.085.005a12.345,12.345,0,0,0,1.3.02c.116-.363.307-.953.307-.953l.091.928c.194-.016.388-.04.578-.071a44.713,44.713,0,0,0,.552-5.826,3.3,3.3,0,0,0-2.075-2.788",
    transform: "translate(-2059.492 -802.3)",
    fill: "#49263e"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139107",
    "data-name": "Path 139107",
    d: "M2272.323,979.85c-.141-.011-.223-.02-.223-.02l.007-.027-2.1.542-.654-.661-.068-.069-.634.881.5.588.029.034.331.393.414-.441.014-.015,0,.013.232.716,2.7-.817-.469-1.114-.084-.005",
    transform: "translate(-2030.138 -867.984)",
    fill: "#9ebee5"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139108",
    "data-name": "Path 139108",
    d: "M2254.934,997.781l3.791-2.579-.033-1.533,1.81-.97a31.484,31.484,0,0,0,1.261-4c-2.246,2.211-6.829,9.078-6.829,9.078",
    transform: "translate(-2017.859 -876.037)",
    fill: "#33182c"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139109",
    "data-name": "Path 139109",
    d: "M2240.84,992.359l.615,1.414-.485.836,1.351,3.7s-.069-6.935-.38-9.009c0,0-1.053,2.674-1.1,3.057",
    transform: "translate(-2005.246 -876.567)",
    fill: "#33182c"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139110",
    "data-name": "Path 139110",
    d: "M2196.573,1192.393l-2.024,2.967-3.172-3.238,3.1,4.483,2.1-2.526,2.106,2.912,11.473-5.8-11.437,4.346Z",
    transform: "translate(-1960.978 -1055.439)",
    fill: "#33182c"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139111",
    "data-name": "Path 139111",
    d: "M2250.779,989.255c.331,3.108.38,8.944.38,9h.113c0-.059-.049-5.9-.381-9.016Z",
    transform: "translate(-2014.141 -876.512)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139112",
    "data-name": "Path 139112",
    d: "M2194.212,1202.178l-3.126-3.191-.077.089,3.218,3.285,2.062-3.022-.091-.073Z",
    transform: "translate(-1960.65 -1062.349)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139113",
    "data-name": "Path 139113",
    d: "M2212.466,1082.069l9.1-.123-9.161-.641Z",
    transform: "translate(-1979.798 -958.081)",
    fill: "#33182c"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139114",
    "data-name": "Path 139114",
    d: "M2242.506,1015.7l-2.1-3.086,1.477-15.169c.228-.343,4.688-7.042,6.812-9.054l-.074-.092c-2.179,2.064-6.792,9.018-6.838,9.088l-.009.013-1.482,15.225,0,.024,2.18,3.2,11.477-4.36-.037-.116Z",
    transform: "translate(-2004.749 -875.679)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139115",
    "data-name": "Path 139115",
    d: "M614.531,786.372c-.406-.334-.866-.766-1.235-1.1a.091.091,0,0,1-.07-.024l-.079-.072a.1.1,0,0,1-.027-.046h0a.111.111,0,0,1,.008-.091l1.107-1.877a.466.466,0,0,0-.091-.591.379.379,0,0,0-.57.114s-1.829,2.764-2.148,3.171l-.31-1.2a.408.408,0,0,0-.429-.392.422.422,0,0,0-.361.466l-.3,4.022c.02-.034.055-.05.117-.015,1.672,1.779,2.493,1.274,2.984,1.709l1.3-2.064a5.069,5.069,0,0,0,.7-1.3c.01-.379-.307-.478-.6-.715",
    transform: "translate(-545.75 -693.33)",
    fill: "#fe9f73"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139116",
    "data-name": "Path 139116",
    d: "M609.819,837.622l.012-.163c-.047.081,0,.272-.012.163",
    transform: "translate(-545.559 -742.033)",
    fill: "#fe9f73"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139117",
    "data-name": "Path 139117",
    d: "M628.591,803.428,627.081,805a.494.494,0,0,0,.007.682.415.415,0,0,0,.6-.018l1.473-1.529a.61.61,0,0,0-.152-.555.427.427,0,0,0-.415-.148",
    transform: "translate(-560.898 -711.873)",
    fill: "#fe9f73"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139118",
    "data-name": "Path 139118",
    d: "M634.4,809.368l-1.483,1.6a.494.494,0,0,0,.019.681.415.415,0,0,0,.6-.031l1.446-1.56a.61.61,0,0,0-.162-.552.426.426,0,0,0-.418-.139",
    transform: "translate(-566.122 -717.135)",
    fill: "#fe9f73"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139119",
    "data-name": "Path 139119",
    d: "M640.394,815.442l-1.365,1.508a.46.46,0,0,0,.025.635.387.387,0,0,0,.557-.036l1.331-1.47a.567.567,0,0,0-.157-.512.4.4,0,0,0-.39-.124",
    transform: "translate(-571.607 -722.516)",
    fill: "#fe9f73"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139120",
    "data-name": "Path 139120",
    d: "M628.408,804.772l-1.467,1.534a.338.338,0,0,1-.487.017.4.4,0,0,1-.006-.554l1.347-1.4a.094.094,0,0,0,0-.124.077.077,0,0,0-.114,0l-1.347,1.4a.581.581,0,0,0-.158.406.572.572,0,0,0,.166.4.49.49,0,0,0,.709-.02l1.467-1.534a.085.085,0,0,0,.011-.014.093.093,0,0,0-.009-.11.076.076,0,0,0-.114,0",
    transform: "translate(-560.209 -712.582)",
    fill: "#f07162"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139121",
    "data-name": "Path 139121",
    d: "M634.15,809.415l-1.39,1.541a.312.312,0,0,1-.464.029.4.4,0,0,1-.016-.553l1.483-1.6a.093.093,0,0,0,0-.124.076.076,0,0,0-.114,0l-1.483,1.6a.582.582,0,0,0-.15.41.57.57,0,0,0,.173.4.465.465,0,0,0,.686-.037l1.391-1.542.009-.013a.093.093,0,0,0-.011-.112.077.077,0,0,0-.114,0",
    transform: "translate(-565.433 -716.536)",
    fill: "#f07162"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139122",
    "data-name": "Path 139122",
    d: "M640.194,815.421l-1.331,1.47a.309.309,0,0,1-.446.031.368.368,0,0,1-.02-.507l1.365-1.508a.093.093,0,0,0,0-.124.076.076,0,0,0-.114,0l-1.365,1.507a.55.55,0,0,0-.138.388.535.535,0,0,0,.167.375.462.462,0,0,0,.667-.041l1.331-1.47.009-.013a.093.093,0,0,0-.01-.111.076.076,0,0,0-.114,0",
    transform: "translate(-570.917 -721.92)",
    fill: "#f07162"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139123",
    "data-name": "Path 139123",
    d: "M485.649,831.948l-4.735,8.145c-1.827,1.179-9.423,7.848-9.535,7.849l2.731,9.541c.2.024,4.215-4.313,11.146-12.95.906-1.128,4.3-10.057,4.3-10.057a8.077,8.077,0,0,0-3.9-2.528",
    transform: "translate(-421.672 -737.15)",
    fill: "#fff"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139124",
    "data-name": "Path 139124",
    d: "M409.577,890.78a4.345,4.345,0,0,0-2.9.47s-.482.944-.527,1.053.6-.3.6-.3l4.384,1.572-.07-.892a2.109,2.109,0,0,0-1.481-1.907",
    transform: "translate(-363.291 -789.187)",
    fill: "#fe9f73"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139125",
    "data-name": "Path 139125",
    d: "M414.071,899.334l-4.55-1.039.217,4.6.13,1.18a20.3,20.3,0,0,0,.021,2.931,2.071,2.071,0,0,0,2.13,1.327,3.179,3.179,0,0,0,1.01-.266,1.434,1.434,0,0,0,.764-1.588l-.342-1.774c1.07-.267.914-1.607.914-1.607Z",
    transform: "translate(-366.312 -795.934)",
    fill: "#fe9f73"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139126",
    "data-name": "Path 139126",
    d: "M427.827,916.795c-.807-.237-1.166.8-1.169.809a.058.058,0,0,0,.031.072.048.048,0,0,0,.039,0,.054.054,0,0,0,.028-.032c.013-.039.33-.948,1.045-.739a.051.051,0,0,0,.064-.04.057.057,0,0,0-.036-.069",
    transform: "translate(-381.646 -812.293)",
    fill: "#4c222e"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139127",
    "data-name": "Path 139127",
    d: "M446.712,914.469a.058.058,0,0,0-.025.075.053.053,0,0,0,.033.03.047.047,0,0,0,.036,0c.005,0,.533-.271.713.019a.049.049,0,0,0,.072.015.059.059,0,0,0,.014-.078c-.23-.37-.818-.071-.843-.058",
    transform: "translate(-399.569 -810.152)",
    fill: "#4c222e"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139128",
    "data-name": "Path 139128",
    d: "M432.981,925.163a.165.165,0,0,0-.142.182.16.16,0,0,0,.168.154.165.165,0,0,0,.142-.182.16.16,0,0,0-.168-.154",
    transform: "translate(-387.18 -819.739)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139129",
    "data-name": "Path 139129",
    d: "M448.52,922.364a.165.165,0,0,0-.142.182.16.16,0,0,0,.168.154.165.165,0,0,0,.142-.182.16.16,0,0,0-.168-.154",
    transform: "translate(-401.087 -817.259)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139130",
    "data-name": "Path 139130",
    d: "M397.467,895.162a1.666,1.666,0,0,0-1.552,1.327,3.783,3.783,0,0,0,.423,2.25c.04.37,0,2.892,1.607,2.557l.115-4.171-.691-1.593Z",
    transform: "translate(-354.088 -793.158)",
    fill: "#49263e"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139131",
    "data-name": "Path 139131",
    d: "M406.717,918.914a.99.99,0,0,0-.85,1.093.958.958,0,0,0,1.007.923.991.991,0,0,0,.85-1.093.958.958,0,0,0-1.007-.923",
    transform: "translate(-363.039 -814.199)",
    fill: "#fe9f73"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139132",
    "data-name": "Path 139132",
    d: "M410.762,923.58a.581.581,0,0,0-.456.009.029.029,0,0,0-.014.037.025.025,0,0,0,.034.015.542.542,0,0,1,.414-.009.44.44,0,0,1,.207.231.41.41,0,0,0-.489.026.417.417,0,0,0-.111.474.39.39,0,0,0,.389.281h.005a.028.028,0,0,0,.023-.031.027.027,0,0,0-.028-.025h-.005a.336.336,0,0,1-.336-.246.363.363,0,0,1,.093-.409.382.382,0,0,1,.5.022l.071.065-.03-.1a.536.536,0,0,0-.266-.345",
    transform: "translate(-367.001 -818.297)",
    fill: "#f07162"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139133",
    "data-name": "Path 139133",
    d: "M422.165,946.5a2.627,2.627,0,0,0,2.854,2.22l-.252-1.309a2.354,2.354,0,0,1-2.6-.911",
    transform: "translate(-377.628 -838.645)",
    fill: "#f07162"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139134",
    "data-name": "Path 139134",
    d: "M441.835,921.745a.028.028,0,0,0-.02.034l.266,1.306-.5.233a.029.029,0,0,0-.014.037.026.026,0,0,0,.026.017l.008,0,.542-.251-.276-1.351a.026.026,0,0,0-.031-.021",
    transform: "translate(-394.988 -816.71)",
    fill: "#f07162"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139135",
    "data-name": "Path 139135",
    d: "M412.719,934.968l-.032,1.912.618,0-.148-1.9Z",
    transform: "translate(-369.145 -828.427)",
    fill: "#fe9f73"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139136",
    "data-name": "Path 139136",
    d: "M405.244,882.047s.063-1.441-1.1-.909-3.37.679-3.9,1.934,1.669,1.582,1.669,1.582,3.925-.616,4.09-1.641-.765-.966-.765-.966",
    transform: "translate(-357.943 -780.628)",
    fill: "#49263e"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139137",
    "data-name": "Path 139137",
    d: "M408.034,906.423a6.1,6.1,0,0,0-.7.511c.1-.029.892-.036.892-.036l.072.924a1.975,1.975,0,0,1,.317,1.214s.249.074.274-.146-.344-1.7.117-2.018-.935-.476-.975-.449",
    transform: "translate(-364.349 -803.133)",
    fill: "#49263e"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139138",
    "data-name": "Path 139138",
    d: "M438.4,938.517c.4-.006.547-.493.547-.493s-1.089.013-1.107.016c0,0,.154.482.559.477",
    transform: "translate(-391.661 -831.134)",
    fill: "#fbfdfc"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139139",
    "data-name": "Path 139139",
    d: "M243.643,1258.89c-.1-.118-.384-.14-.62-.1a31.137,31.137,0,0,1-3.3-.858l-.023.545-.109,2.619a7.015,7.015,0,0,1-.465,2.306l-.071.184a.447.447,0,0,0,.24.581.4.4,0,0,0,.506-.258l.514-1.332a.1.1,0,0,1,.1-.065.1.1,0,0,1,.088.133l-.513,2.059a.348.348,0,0,0,.3.459.526.526,0,0,0,.515-.4l.523-2.1a.1.1,0,0,1,.1-.078l.033,0a.1.1,0,0,1,.091.113l-.15,2.407a.44.44,0,0,0,.346.477.412.412,0,0,0,.455-.4l.151-2.422a.1.1,0,0,1,.1-.1l.1.008a.1.1,0,0,1,.091.1l.13,2.251a.428.428,0,0,0,.4.423.422.422,0,0,0,.4-.463s-.028-3.444.007-3.983l.913.778a.38.38,0,0,0,.567.042h0a.462.462,0,0,0,.038-.615Z",
    transform: "translate(-213.722 -1114.576)",
    fill: "#fe9f73"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139140",
    "data-name": "Path 139140",
    d: "M245.133,1217.494l4.174-.1,1.062-6.2-4.768-.435c-.271,3.457-.468,6.741-.468,6.741",
    transform: "translate(-219.194 -1072.774)",
    fill: "#fe9f73"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139141",
    "data-name": "Path 139141",
    d: "M369.29,1611.9l4.945-.424.6-7.175-5.357,1.448Z",
    transform: "translate(-330.307 -1421.458)",
    fill: "#fe9f73"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139142",
    "data-name": "Path 139142",
    d: "M376.14,1658.684l-.681,0-3.155-2.051-1.732,2.037-4.261-.012a.2.2,0,0,0-.193.208l0,.7a.138.138,0,0,0,.131.144l9.907.027a.516.516,0,0,0,.477-.629.507.507,0,0,0-.493-.423",
    transform: "translate(-327.468 -1467.825)",
    fill: "#33182c"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139143",
    "data-name": "Path 139143",
    d: "M376.868,1652.826l-3.614-1.751a2.312,2.312,0,0,1-3.11.259,1.455,1.455,0,0,0-1.811.508l0,1.9,9.8.027c-.267-.578-1.258-.94-1.258-.94",
    transform: "translate(-329.448 -1462.901)",
    fill: "#49263e"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18723",
    "data-name": "Rectangle 18723",
    width: 1.888,
    height: 0.072,
    transform: "matrix(0.003, -1, 1, 0.003, 38.845, 190.829)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139144",
    "data-name": "Path 139144",
    d: "M385.458,1653.062l-.041.065a2.526,2.526,0,0,0,1.5.505,1.623,1.623,0,0,0,.225-.013l-.011-.078a2.407,2.407,0,0,1-1.673-.48",
    transform: "translate(-344.74 -1464.662)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139238",
    "data-name": "Path 139238",
    d: "M.022,0,.1,0,.077.572,0,.575Z",
    transform: "matrix(0.561, -0.828, 0.828, 0.561, 39.287, 190.164)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139239",
    "data-name": "Path 139239",
    d: "M.022,0,.1,0,.077.572,0,.575Z",
    transform: "matrix(0.561, -0.828, 0.828, 0.561, 39.618, 190.069)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139145",
    "data-name": "Path 139145",
    d: "M375.851,1674.113l-9.8-.027a.292.292,0,0,0-.28.3v.525h.073v-.525a.216.216,0,0,1,.207-.224l9.8.027a.47.47,0,0,1,.447.488.5.5,0,0,1-.159.371l.047.06a.585.585,0,0,0,.185-.431.546.546,0,0,0-.52-.567",
    transform: "translate(-327.161 -1483.289)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139146",
    "data-name": "Path 139146",
    d: "M419.062,1652.664c-.727-.339-3.924-1.888-3.956-1.9l-.03.072c.032.016,3.23,1.565,3.957,1.9a1.818,1.818,0,0,1,.908.766l.066-.033a1.844,1.844,0,0,0-.945-.805",
    transform: "translate(-371.284 -1462.623)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139147",
    "data-name": "Path 139147",
    d: "M514.3,1599.954l1.058,8.087,5.025-.446-.953-7.251Z",
    transform: "translate(-460.086 -1417.608)",
    fill: "#fe9f73"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139148",
    "data-name": "Path 139148",
    d: "M530.372,1658.684l-.681,0-3.155-2.051-1.732,2.037-4.261-.012a.2.2,0,0,0-.193.208l0,.7a.138.138,0,0,0,.131.144l9.907.027a.516.516,0,0,0,.477-.629.507.507,0,0,0-.493-.423",
    transform: "translate(-465.497 -1467.825)",
    fill: "#33182c"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139149",
    "data-name": "Path 139149",
    d: "M531.1,1652.826l-3.614-1.751a2.312,2.312,0,0,1-3.11.259,1.455,1.455,0,0,0-1.811.508l0,1.9,9.8.027c-.267-.578-1.258-.94-1.258-.94",
    transform: "translate(-467.477 -1462.901)",
    fill: "#49263e"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18726",
    "data-name": "Rectangle 18726",
    width: 1.888,
    height: 0.072,
    transform: "translate(55.047 190.829) rotate(-89.834)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139150",
    "data-name": "Path 139150",
    d: "M539.69,1653.062l-.041.065a2.526,2.526,0,0,0,1.5.505,1.62,1.62,0,0,0,.225-.013l-.011-.078a2.407,2.407,0,0,1-1.673-.48",
    transform: "translate(-482.77 -1464.662)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139151",
    "data-name": "Path 139151",
    d: "M526.559,1667.88l.461.34.041-.065-.461-.339Z",
    transform: "translate(-471.055 -1477.733)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139240",
    "data-name": "Path 139240",
    d: "M.022,0,.1,0,.077.572,0,.575Z",
    transform: "matrix(0.561, -0.828, 0.828, 0.561, 55.821, 190.069)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139152",
    "data-name": "Path 139152",
    d: "M530.083,1674.113l-9.8-.027a.292.292,0,0,0-.28.3v.525h.073v-.525a.216.216,0,0,1,.207-.224l9.8.027a.47.47,0,0,1,.448.488.5.5,0,0,1-.159.371l.047.06a.585.585,0,0,0,.185-.431.546.546,0,0,0-.52-.567",
    transform: "translate(-465.19 -1483.289)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139153",
    "data-name": "Path 139153",
    d: "M573.294,1652.664c-.727-.339-3.924-1.888-3.956-1.9l-.03.072c.032.016,3.23,1.565,3.957,1.9a1.818,1.818,0,0,1,.908.766l.066-.033a1.844,1.844,0,0,0-.945-.805",
    transform: "translate(-509.313 -1462.623)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139154",
    "data-name": "Path 139154",
    d: "M431.5,1190.8a2.093,2.093,0,0,0-.065-.32l-.061-.215a1.75,1.75,0,0,0-2.593-1.117l-6.232,3.824a2,2,0,0,0-.881,2.042c.964,5.691,8.172,45.759,10.126,46.375.963.3,5.849-.827,5.747-1.667Z",
    transform: "translate(-377.154 -1053.41)",
    fill: "#33192c"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139155",
    "data-name": "Path 139155",
    d: "M354.062,1203.873c.134,7.091-1.506,17.341-1.054,23.464.06.812,6.984.053,7.036-.637l2.781-22.439.462-19.9,1.9-11.087-12.838,6.444s1.47,11.378,1.712,24.151",
    transform: "translate(-315.147 -1039.571)",
    fill: "#49263e"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139156",
    "data-name": "Path 139156",
    d: "M431.046,1314.188a.08.08,0,0,0-.079.081l-.344,14.833-2.43,19.283a.082.082,0,0,0,.066.094.064.064,0,0,0,.022,0,.08.08,0,0,0,.065-.071l2.431-19.288v0l.345-14.842a.08.08,0,0,0-.075-.085",
    transform: "translate(-383.022 -1164.417)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139157",
    "data-name": "Path 139157",
    d: "M359.7,1304.506c-.012-.183-.921-15.208-.93-15.361a.079.079,0,0,0-.082-.078.081.081,0,0,0-.072.089l.92,15.191c0,.077.008.131.013.169h0c0,.04,0,.1-.005.184-.043,2.959-.145,8.335-.346,11.1a.082.082,0,0,0,.071.09h.017a.081.081,0,0,0,.065-.076c.2-2.765.3-8.145.347-11.106,0-.044,0-.081,0-.11h0l0-.082s0,0,0-.005",
    transform: "translate(-320.753 -1142.16)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139158",
    "data-name": "Path 139158",
    d: "M522.907,1265.793a.08.08,0,0,0-.066.094l4.414,36.191a.078.078,0,0,0,.086.072h0a.083.083,0,0,0,.065-.093l-4.414-36.191a.078.078,0,0,0-.086-.072",
    transform: "translate(-467.727 -1121.539)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139159",
    "data-name": "Path 139159",
    d: "M262.419,970.413c-.486-.061-2.266.725-2.821.669-2.731-.278-5.977-.426-7.571.207-2.962,1.176-13.312,14.112-13.813,16.486s-1.421,15.082-1.421,15.082,1.163,1.04,6.338.67c0,0,2.123-11.307,2.8-12.413s2.966-5.164,2.966-5.164l.043,17.956s9.379,2.205,18.11-1.777c0,0-1.367-16.576-2.349-27.483-.166-1.844-.584-4.019-2.28-4.232",
    transform: "translate(-211.73 -859.828)",
    fill: "#fff"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139160",
    "data-name": "Path 139160",
    d: "M249.843,1076.811a.115.115,0,0,0-.166.041L244.8,1085.3l-.013.03a100.939,100.939,0,0,0-2.789,12.33c-.671.046-4.637.275-6.174-.661a.115.115,0,0,0-.163.05.136.136,0,0,0,.046.177,10.1,10.1,0,0,0,4.5.756c1.033,0,1.83-.063,1.908-.07l.1-.008.013-.105a99.224,99.224,0,0,1,2.789-12.375l4.866-8.432a.137.137,0,0,0-.038-.18",
    transform: "translate(-210.707 -954.082)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139161",
    "data-name": "Path 139161",
    d: "M350.968,1105.586h0a.125.125,0,0,0-.12.131l.024,10.116a.126.126,0,0,0,.12.13h0a.126.126,0,0,0,.12-.131l-.024-10.116a.125.125,0,0,0-.12-.13",
    transform: "translate(-313.803 -979.595)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139162",
    "data-name": "Path 139162",
    d: "M285,980.061c-.038.029-3.918,2.956-10.556,11.768a.138.138,0,0,0,.017.183.114.114,0,0,0,.076.029.116.116,0,0,0,.093-.048c6.611-8.777,10.467-11.689,10.505-11.718a.138.138,0,0,0,.031-.181.114.114,0,0,0-.167-.034",
    transform: "translate(-245.401 -868.359)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139163",
    "data-name": "Path 139163",
    d: "M441.209,983.406a.164.164,0,0,0-.134.186c.026.224,2.557,22.565,1.856,32.039-.007.092.045.09.129.1a.14.14,0,0,0,.035,0c.069-.011.136.01.142-.069.7-9.507-1.831-31.882-1.857-32.106a.157.157,0,0,0-.171-.145",
    transform: "translate(-394.55 -871.342)",
    fill: "#9ebee5"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139164",
    "data-name": "Path 139164",
    d: "M435.681,971.416l-.015,1,.569.432.453-.121.262-.906-.611-.545Z",
    transform: "translate(-389.711 -860.599)",
    fill: "#fc4963"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139165",
    "data-name": "Path 139165",
    d: "M413.652,964.939l-2.919-.567-.054,1.291,2.6.854.427-1.057.81.865.757-.586-.455-1.307Z",
    transform: "translate(-367.349 -854.478)",
    fill: "#9ebee5"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139166",
    "data-name": "Path 139166",
    d: "M413.612,995.465a.128.128,0,0,0-.109.142l2.509,28.644c-.6.326-5.022,2.574-12.5,2.321a.131.131,0,0,0-.124.126.126.126,0,0,0,.116.134q.6.02,1.169.02c7.361,0,11.483-2.386,11.525-2.412l.069-.041-2.524-28.817a.125.125,0,0,0-.131-.118",
    transform: "translate(-360.821 -882.027)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139167",
    "data-name": "Path 139167",
    d: "M441.03,979.966c-.3-.383-.282-.074-.539-.549.054.26.011.447.078.681,1.559,5.4,6.762,4.5,10.518,5.607a1.922,1.922,0,0,1,.671.353c1.426,1.161,1.291,3.425,1.88,4.978,3.3-10.135-7.572-4.728-12.608-11.07",
    transform: "translate(-394.029 -867.808)",
    fill: "#fc4963"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139168",
    "data-name": "Path 139168",
    d: "M2654.736,1621.532l5.006.075.075-5.377-4.986-.706Z",
    transform: "translate(-2375.661 -1431.404)",
    fill: "#fe9f73"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139169",
    "data-name": "Path 139169",
    d: "M2615.243,1650.9a2.35,2.35,0,0,1-3.16-.272l-3.677,1.77s-1.35.488-1.35,1.243h10.026v-2.219a1.479,1.479,0,0,0-1.839-.521",
    transform: "translate(-2332.989 -1462.506)",
    fill: "#33192c"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18728",
    "data-name": "Rectangle 18728",
    width: 0.074,
    height: 1.885,
    transform: "translate(284.056 188.916)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139170",
    "data-name": "Path 139170",
    d: "M2668.5,1653.206l-.011.079a1.61,1.61,0,0,0,.228.014,2.568,2.568,0,0,0,1.526-.51l-.042-.066a2.446,2.446,0,0,1-1.7.483",
    transform: "translate(-2387.964 -1464.361)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139241",
    "data-name": "Path 139241",
    d: "M0,.022.584,0l0,.078L0,.1Z",
    transform: "matrix(0.83, -0.558, 0.558, 0.83, 283.142, 190.401)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139242",
    "data-name": "Path 139242",
    d: "M0,.022.584,0l0,.078L0,.1Z",
    transform: "matrix(0.829, -0.559, 0.559, 0.829, 282.806, 190.304)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139171",
    "data-name": "Path 139171",
    d: "M2613.49,1674.487h-10.284a.307.307,0,0,0-.294.319v.432a.307.307,0,0,0,.294.319h10.284a.124.124,0,0,0,.118-.128v-.813a.124.124,0,0,0-.118-.128",
    transform: "translate(-2329.281 -1483.645)",
    fill: "#241f2b"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139172",
    "data-name": "Path 139172",
    d: "M2608.248,1652.231a1.876,1.876,0,0,0-.962.816l.067.034a1.844,1.844,0,0,1,.925-.776c.74-.343,3.993-1.908,4.026-1.924l-.03-.073c-.033.016-3.286,1.581-4.025,1.923",
    transform: "translate(-2333.194 -1462.222)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139173",
    "data-name": "Path 139173",
    d: "M2613.046,1674.136h-9.956a.554.554,0,0,0-.53.574.6.6,0,0,0,.187.438l.047-.061a.514.514,0,0,1-.161-.377.477.477,0,0,1,.456-.495h9.956a.22.22,0,0,1,.21.228v.533h.074v-.533a.3.3,0,0,0-.284-.308",
    transform: "translate(-2328.966 -1483.334)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139174",
    "data-name": "Path 139174",
    d: "M2744.386,1620.848l5.007.075.074-5.376-4.986-.706Z",
    transform: "translate(-2455.892 -1430.797)",
    fill: "#fe9f73"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139175",
    "data-name": "Path 139175",
    d: "M2634.19,1217.886l.432,44.635a13.838,13.838,0,0,0,7.1,1.026c2.253-16.2,3.282-44.269,3.282-44.269l-10.388-4.046Z",
    transform: "translate(-2357.273 -1076.743)",
    fill: "#1c0d19"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139176",
    "data-name": "Path 139176",
    d: "M2646.489,1512.925a.056.056,0,0,0-.055.054c-.118,2.506-1.405,13.509-1.5,14.284a14.632,14.632,0,0,1-7.065-1.049.051.051,0,0,0-.068.032.059.059,0,0,0,.029.074,16.088,16.088,0,0,0,5.607,1.176,9.073,9.073,0,0,0,1.552-.127l.039-.007,0-.042c.014-.117,1.379-11.745,1.5-14.334a.055.055,0,0,0-.049-.059",
    transform: "translate(-2360.505 -1340.499)",
    fill: "#21111d"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139177",
    "data-name": "Path 139177",
    d: "M2682.118,1198.6l1.974,10.636,3.151,39.333a13.811,13.811,0,0,0,7.143.625c1.476-16.3,1.162-44.394,1.162-44.394Z",
    transform: "translate(-2400.166 -1062.009)",
    fill: "#281323"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139178",
    "data-name": "Path 139178",
    d: "M2738.785,1274.908h0a.055.055,0,0,0-.05.059c.384,10.877-1.112,40.481-1.178,41.791-2.875.7-7.036-.62-7.078-.634a.051.051,0,0,0-.065.038.057.057,0,0,0,.035.07,19.606,19.606,0,0,0,5.18.844,8.217,8.217,0,0,0,1.99-.218l.038-.01,0-.042c.016-.307,1.572-30.771,1.181-41.844a.055.055,0,0,0-.052-.054m-1.18,41.9h0Z",
    transform: "translate(-2443.385 -1129.615)",
    fill: "#21111d"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139179",
    "data-name": "Path 139179",
    d: "M2775.5,1363.182a.055.055,0,0,0-.047.062c.326,3.5-.417,31.694-.424,31.978a.054.054,0,0,0,.051.058h0a.054.054,0,0,0,.052-.055c.008-.284.751-28.484.424-31.993a.053.053,0,0,0-.057-.051",
    transform: "translate(-2483.319 -1207.826)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139180",
    "data-name": "Path 139180",
    d: "M2686.478,1371.144a.053.053,0,0,0-.055.054l-1.249,30.561a.055.055,0,0,0,.05.059h0a.054.054,0,0,0,.052-.054l1.249-30.561a.055.055,0,0,0-.05-.059",
    transform: "translate(-2402.9 -1214.881)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139181",
    "data-name": "Path 139181",
    d: "M2704.894,1650.217a2.35,2.35,0,0,1-3.16-.272l-3.677,1.77s-1.35.488-1.35,1.243h10.026v-2.219a1.479,1.479,0,0,0-1.84-.521",
    transform: "translate(-2413.222 -1461.9)",
    fill: "#49263e"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18731",
    "data-name": "Rectangle 18731",
    width: 0.074,
    height: 1.885,
    transform: "translate(293.474 188.838)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139182",
    "data-name": "Path 139182",
    d: "M2758.145,1652.522l-.011.079a1.6,1.6,0,0,0,.229.014,2.567,2.567,0,0,0,1.526-.51l-.042-.066a2.444,2.444,0,0,1-1.7.483",
    transform: "translate(-2468.196 -1463.755)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139243",
    "data-name": "Path 139243",
    d: "M0,.022.584,0l0,.078L0,.1Z",
    transform: "matrix(0.83, -0.558, 0.558, 0.83, 292.56, 190.323)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139244",
    "data-name": "Path 139244",
    d: "M0,.022.584,0l0,.078L0,.1Z",
    transform: "matrix(0.829, -0.559, 0.559, 0.829, 292.223, 190.226)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139183",
    "data-name": "Path 139183",
    d: "M2703.139,1673.8h-10.284a.307.307,0,0,0-.293.319v.432a.307.307,0,0,0,.293.318h10.284a.123.123,0,0,0,.118-.128v-.813a.124.124,0,0,0-.118-.128",
    transform: "translate(-2409.512 -1483.038)",
    fill: "#312939"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139184",
    "data-name": "Path 139184",
    d: "M2697.9,1651.547a1.874,1.874,0,0,0-.963.816l.066.034a1.844,1.844,0,0,1,.925-.776c.74-.343,3.993-1.909,4.026-1.924l-.03-.073c-.033.016-3.285,1.581-4.025,1.923",
    transform: "translate(-2413.427 -1461.616)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139185",
    "data-name": "Path 139185",
    d: "M2702.7,1673.451h-9.956a.554.554,0,0,0-.53.575.6.6,0,0,0,.187.438l.048-.061a.513.513,0,0,1-.161-.378.477.477,0,0,1,.456-.495h9.956a.22.22,0,0,1,.21.228v.533h.074v-.533a.3.3,0,0,0-.284-.308",
    transform: "translate(-2409.197 -1482.727)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139186",
    "data-name": "Path 139186",
    d: "M2648.251,959.024a37.146,37.146,0,0,0-8.527-1.455,14.473,14.473,0,0,1-5.573-1.018,26.275,26.275,0,0,1-2.369-1.4l-1.3,11.568-.34,22.287.061.086c12.513,1.6,19.045,0,19.045,0l.09-7.578,1.179-.027c3.241-.544,3.775-3.526,3.241-8.13s-3.047-13.5-5.506-14.332",
    transform: "translate(-2353.649 -846.307)",
    fill: "#fff"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139187",
    "data-name": "Path 139187",
    d: "M2778.158,1056.891l-.206.018.5,6.652,1.37,1.256.133-.171-1.3-1.2Z",
    transform: "translate(-2485.932 -936.451)",
    fill: "#21111d"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139188",
    "data-name": "Path 139188",
    d: "M2817.172,1114.763c.6,5.2-.308,7.525-3.147,8l-1.172.027,0,.224,1.193-.028a3.681,3.681,0,0,0,3.117-2.615,13.363,13.363,0,0,0,.211-5.641Z",
    transform: "translate(-2517.166 -987.701)",
    fill: "#21111d"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139189",
    "data-name": "Path 139189",
    d: "M2739,988.614l.109.19a5.283,5.283,0,0,0,2.127-3.068l-.2-.061a5.061,5.061,0,0,1-2.037,2.938",
    transform: "translate(-2451.071 -873.354)",
    fill: "#21111d"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139190",
    "data-name": "Path 139190",
    d: "M2707.284,899.485a4.381,4.381,0,0,0-2.85-.739,2.066,2.066,0,0,0-1.625,1.758l-.14.88,4.485-1.153s.607.463.571.35-.441-1.1-.441-1.1",
    transform: "translate(-2418.558 -796.297)",
    fill: "#fe9f73"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139191",
    "data-name": "Path 139191",
    d: "M2698.283,912.613s-.262,1.317.781,1.683l-.482,1.733a1.452,1.452,0,0,0,.634,1.651,3.214,3.214,0,0,0,.983.358,2.034,2.034,0,0,0,2.224-1.12,20.206,20.206,0,0,0,.254-2.913l.223-1.161.581-4.552-4.609.607Z",
    transform: "translate(-2414.606 -804.791)",
    fill: "#fe9f73"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139192",
    "data-name": "Path 139192",
    d: "M2717.058,925.94a.06.06,0,0,0-.009.079.049.049,0,0,0,.073.01c.584-.492,1.2.212,1.225.243a.049.049,0,0,0,.037.018.05.05,0,0,0,.036-.015.06.06,0,0,0,0-.079c-.007-.008-.706-.811-1.364-.255",
    transform: "translate(-2431.417 -820.253)",
    fill: "#4c222e"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139193",
    "data-name": "Path 139193",
    d: "M2701.38,920.054a.059.059,0,0,0-.02.076.05.05,0,0,0,.07.022c.281-.17.639.328.643.333a.05.05,0,0,0,.03.021.049.049,0,0,0,.042-.011.059.059,0,0,0,.009-.079c-.017-.024-.415-.579-.774-.363",
    transform: "translate(-2417.381 -815.168)",
    fill: "#4c222e"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139194",
    "data-name": "Path 139194",
    d: "M2719.619,932.873a.157.157,0,0,0-.179.137.168.168,0,0,0,.127.194.157.157,0,0,0,.179-.137.167.167,0,0,0-.126-.195",
    transform: "translate(-2433.565 -826.568)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139195",
    "data-name": "Path 139195",
    d: "M2704.406,928.749a.157.157,0,0,0-.179.137.168.168,0,0,0,.127.195.157.157,0,0,0,.179-.137.167.167,0,0,0-.126-.194",
    transform: "translate(-2419.95 -822.914)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139196",
    "data-name": "Path 139196",
    d: "M2738.477,905.037l.068.378-.815,1.52-.218,4.159c1.568.484,1.732-2.029,1.8-2.393a3.744,3.744,0,0,0,.6-2.2,1.693,1.693,0,0,0-1.438-1.465",
    transform: "translate(-2449.741 -801.907)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139197",
    "data-name": "Path 139197",
    d: "M2732.522,928.327a.941.941,0,0,0-1.076.823,1,1,0,0,0,.759,1.167.941.941,0,0,0,1.076-.823,1,1,0,0,0-.759-1.167",
    transform: "translate(-2444.3 -822.529)",
    fill: "#fe9f73"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139198",
    "data-name": "Path 139198",
    d: "M2738.233,933.17a.584.584,0,0,0-.452-.051.526.526,0,0,0-.292.319l-.038.092.076-.058a.38.38,0,0,1,.5.024.365.365,0,0,1,.06.415.331.331,0,0,1-.354.213h-.005a.026.026,0,0,0-.03.023.028.028,0,0,0,.021.033h.005a.384.384,0,0,0,.409-.243.419.419,0,0,0-.073-.482.41.41,0,0,0-.484-.072.432.432,0,0,1,.224-.21.544.544,0,0,1,.412.048.025.025,0,0,0,.035-.011.029.029,0,0,0-.01-.038",
    transform: "translate(-2449.686 -826.764)",
    fill: "#f07162"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139199",
    "data-name": "Path 139199",
    d: "M2702.947,955.813l-.355,1.278a2.579,2.579,0,0,0,3.015-1.941,2.332,2.332,0,0,1-2.66.662",
    transform: "translate(-2418.489 -846.309)",
    fill: "#f07162"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139200",
    "data-name": "Path 139200",
    d: "M2708.159,930.211l-.482-.279.369-1.274a.028.028,0,0,0-.017-.035.025.025,0,0,0-.032.018l-.382,1.318.52.3.008,0a.026.026,0,0,0,.027-.015.029.029,0,0,0-.011-.038",
    transform: "translate(-2422.984 -822.804)",
    fill: "#f07162"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139201",
    "data-name": "Path 139201",
    d: "M2734.415,946.093l.615.06.12-1.905-.436-.029Z",
    transform: "translate(-2446.969 -836.622)",
    fill: "#fe9f73"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139202",
    "data-name": "Path 139202",
    d: "M2525.042,834.33c-.008.109.035-.082-.012-.163Z",
    transform: "translate(-2259.58 -739.116)",
    fill: "#fe9f73"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139203",
    "data-name": "Path 139203",
    d: "M2480.874,780.976a.408.408,0,0,0-.429.392l-.31,1.2c-.318-.407-2.147-3.171-2.147-3.171a.379.379,0,0,0-.57-.114.465.465,0,0,0-.091.591l1.106,1.877a.109.109,0,0,1,.008.091h0a.1.1,0,0,1-.027.046l-.079.072a.09.09,0,0,1-.07.024c-.369.331-.829.763-1.235,1.1-.289.238-.606.337-.6.715a5.062,5.062,0,0,0,.7,1.3l1.3,2.064c.491-.435,1.312.071,2.984-1.709.062-.034.1-.019.117.016l-.3-4.022a.422.422,0,0,0-.361-.466",
    transform: "translate(-2216.089 -690.413)",
    fill: "#fe9f73"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139204",
    "data-name": "Path 139204",
    d: "M2487.439,800.135a.426.426,0,0,0-.415.147.611.611,0,0,0-.153.555l1.473,1.529a.415.415,0,0,0,.6.018.5.5,0,0,0,.007-.682Z",
    transform: "translate(-2225.411 -708.956)",
    fill: "#fe9f73"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139205",
    "data-name": "Path 139205",
    d: "M2481.834,806.076a.427.427,0,0,0-.418.139.609.609,0,0,0-.162.552l1.446,1.56a.415.415,0,0,0,.6.031.494.494,0,0,0,.019-.681Z",
    transform: "translate(-2220.385 -714.218)",
    fill: "#fe9f73"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139206",
    "data-name": "Path 139206",
    d: "M2477.239,812.149a.4.4,0,0,0-.39.124.568.568,0,0,0-.157.512l1.331,1.47a.387.387,0,0,0,.556.036.46.46,0,0,0,.025-.635Z",
    transform: "translate(-2216.305 -719.598)",
    fill: "#fe9f73"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139207",
    "data-name": "Path 139207",
    d: "M2487.2,800.951a.076.076,0,0,0-.114,0,.094.094,0,0,0,0,.124l1.347,1.4a.4.4,0,0,1-.006.554.338.338,0,0,1-.488-.017l-1.467-1.534a.076.076,0,0,0-.114,0,.094.094,0,0,0-.009.11.064.064,0,0,0,.011.014l1.467,1.534a.491.491,0,0,0,.709.019.573.573,0,0,0,.166-.4.583.583,0,0,0-.158-.406Z",
    transform: "translate(-2224.957 -709.665)",
    fill: "#f07162"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139208",
    "data-name": "Path 139208",
    d: "M2482.036,805.416a.077.077,0,0,0-.115,0,.093.093,0,0,0,0,.124l1.483,1.6a.4.4,0,0,1-.015.553.312.312,0,0,1-.465-.029l-1.39-1.541a.077.077,0,0,0-.115,0,.093.093,0,0,0-.011.112l.009.013,1.391,1.542a.465.465,0,0,0,.687.037.571.571,0,0,0,.173-.4.583.583,0,0,0-.151-.41Z",
    transform: "translate(-2220.53 -713.619)",
    fill: "#f07162"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139209",
    "data-name": "Path 139209",
    d: "M2476.756,811.492a.077.077,0,0,0-.115,0,.094.094,0,0,0,0,.124l1.365,1.507a.36.36,0,0,1,.091.258.356.356,0,0,1-.111.249.309.309,0,0,1-.446-.031l-1.331-1.47a.077.077,0,0,0-.115,0,.093.093,0,0,0-.01.111.088.088,0,0,0,.01.013l1.331,1.47a.463.463,0,0,0,.667.041.537.537,0,0,0,.167-.375.554.554,0,0,0-.138-.388Z",
    transform: "translate(-2215.764 -719.003)",
    fill: "#f07162"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139210",
    "data-name": "Path 139210",
    d: "M2494.588,828.655a8.076,8.076,0,0,0-3.9,2.528s3.389,8.929,4.3,10.057c6.932,8.637,10.942,12.974,11.146,12.95l2.731-9.541c-.112,0-7.708-6.671-9.535-7.849Z",
    transform: "translate(-2228.844 -734.232)",
    fill: "#fff"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139211",
    "data-name": "Path 139211",
    d: "M2707.8,945.491c.38-.1.415-.593.415-.593-.017,0-1.037.278-1.037.278s.243.417.622.315",
    transform: "translate(-2422.593 -837.224)",
    fill: "#fbfdfc"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139212",
    "data-name": "Path 139212",
    d: "M2691.4,989.184a.156.156,0,0,0-.171.145c-.024.213-2.289,20.192-1.945,30.416,0,.075.005.149.008.223l.308.017c0-.074-.006-.148-.008-.223-.349-10.182,1.917-30.18,1.942-30.392a.163.163,0,0,0-.133-.186",
    transform: "translate(-2406.547 -876.46)",
    fill: "#9ebee5"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139213",
    "data-name": "Path 139213",
    d: "M2697.289,975.348l-.478.195.349,1.713,1.777.362,2.306-.13.136-1.755h-2.191Z",
    transform: "translate(-2413.315 -864.203)",
    fill: "#fff"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139214",
    "data-name": "Path 139214",
    d: "M2704.817,977.057l-.611.545.261.906.453.121.569-.432-.015-1Z",
    transform: "translate(-2419.934 -865.718)",
    fill: "#fc4963"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139215",
    "data-name": "Path 139215",
    d: "M2700.531,966.909l-.979-1.057-.5,1.052.608,1.39.811-.865.427,1.057,2.813-1.239-.326-1.4Z",
    transform: "translate(-2415.323 -855.79)",
    fill: "#9ebee5"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139216",
    "data-name": "Path 139216",
    d: "M2646.818,1121.515c-.624-.462-.615,0-.482.274.257.539.44,1.59-.134,1.634-.808-.405-2.131-.969-2.565-1.151a.433.433,0,0,0-.416.037c-.169.116-.276.368.185.909,0,0-.989.152-.045,1.054,0,0-1.04-.057-.075,1.042,0,0-.636.049.375,1a7.143,7.143,0,0,0,2.953,1.212c.551,0,4.207.06,4.207.06l.477-4.789-3.2.334a8.094,8.094,0,0,0-1.275-1.619",
    transform: "translate(-2365.044 -993.533)",
    fill: "#fe9f73"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139217",
    "data-name": "Path 139217",
    d: "M2648.544,1138.081a8.078,8.078,0,0,1-1.149-.712.063.063,0,0,0-.092.019.076.076,0,0,0,.017.1,7.963,7.963,0,0,0,1.173.726.059.059,0,0,0,.02.005.066.066,0,0,0,.067-.044.075.075,0,0,0-.036-.094",
    transform: "translate(-2368.998 -1007.743)",
    fill: "#f07162"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139218",
    "data-name": "Path 139218",
    d: "M2648.088,1147.178a3.986,3.986,0,0,1-1.12-.562.063.063,0,0,0-.092.018.075.075,0,0,0,.016.1,4.05,4.05,0,0,0,1.161.583l.012,0a.067.067,0,0,0,.069-.053.073.073,0,0,0-.047-.088",
    transform: "translate(-2368.615 -1015.936)",
    fill: "#f07162"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139219",
    "data-name": "Path 139219",
    d: "M2647.225,1156.3a3.454,3.454,0,0,1-.973-.542.063.063,0,0,0-.093.014.076.076,0,0,0,.013.1,3.536,3.536,0,0,0,1.015.565l.014,0a.067.067,0,0,0,.068-.051.073.073,0,0,0-.044-.089",
    transform: "translate(-2367.972 -1024.033)",
    fill: "#f07162"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139220",
    "data-name": "Path 139220",
    d: "M2702.977,1116.366s-.652,2.23.131,6.751c.076.439.236,1.19.236,1.19s3.272.283,3.786-.87c.323-.724-.383-3.853-.383-3.853l2.859-3.677Z",
    transform: "translate(-2418.606 -988.738)",
    fill: "#fff"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139221",
    "data-name": "Path 139221",
    d: "M2701.932,1122.445c-.155-.7-1.15-5.392-.375-7.718l8.186-.569-.013-.224-8.319.578-.024.067c-.9,2.542.312,7.786.364,8.008l.021.087,11.032-.365-.006-.224Z",
    transform: "translate(-2417.114 -986.991)",
    fill: "#21111d"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139222",
    "data-name": "Path 139222",
    d: "M2636.319,1052.664l-.308-.017c-2.509-.142-5.519-.526-6.08-.6l.384-25.726-.207,0-.386,25.927.092.013c.042.006,3.431.457,6.2.613l.309.017c.47.023.918.036,1.322.036h.181l0-.224c-.451.005-.965-.009-1.509-.035",
    transform: "translate(-2353.274 -909.363)",
    fill: "#21111d"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139223",
    "data-name": "Path 139223",
    d: "M2599.066,985.743c-5.036,6.342-12.43,1.206-12.608,11.07a7.43,7.43,0,0,1,3.042-3.621,7.95,7.95,0,0,1,1.971-.8c3.755-1.109,6.5-1.12,8.055-6.519.067-.235.024-.422.078-.682-.257.476-.234.166-.539.549",
    transform: "translate(-2314.555 -872.927)",
    fill: "#fc4963"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139224",
    "data-name": "Path 139224",
    d: "M2699.881,882.814c-.04.055.189.386.275.557-.383-.132-.733-.237-1.007-.312-1.319-.363-.4,1.353-.4,1.353s-.914-.12-1.146.662c-.267.9,3.23,1.835,3.845,1.992.215.51-.165,1.659-.158,1.855.007.221.261.171.261.171a1.945,1.945,0,0,1,.412-1.178l.145-.911h.005c.063.007.783.082.879.119.053.02-.12-.131-.3-.284.548-.206,1.055-.58.83-1.223-.634-1.808-3.378-3.157-3.637-2.8",
    transform: "translate(-2414.008 -782.166)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139225",
    "data-name": "Path 139225",
    d: "M767.047,664.615a2.042,2.042,0,0,0-1.492-.25s.966-4.384-1.765-4.911-3.63,2.487-3.63,2.487c.043-2-4.405-5.768-6.964-1.824a5.17,5.17,0,0,0-.937,2.7,3.226,3.226,0,0,0,1.662,2.937h13.274a.818.818,0,0,0-.147-1.142",
    transform: "translate(-673.043 -583.375)",
    fill: "#fff"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139226",
    "data-name": "Path 139226",
    d: "M2225.09,435.706a2.042,2.042,0,0,0-1.492-.25s.966-4.384-1.765-4.911-3.63,2.487-3.63,2.487c.043-2-4.405-5.768-6.964-1.824a5.171,5.171,0,0,0-.938,2.705,3.227,3.227,0,0,0,1.663,2.937h13.274a.818.818,0,0,0-.147-1.142",
    transform: "translate(-1977.913 -380.56)",
    fill: "#fff"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139227",
    "data-name": "Path 139227",
    d: "M951.382,495.974s.418-8.162-5.264-8.7c-6.517-.62-6.6,7.4-6.6,7.4s-2.962-3.051-5.1.817a3.672,3.672,0,0,0-5.554,1.961.722.722,0,0,0-.05.405h25.22a1.232,1.232,0,0,0-.3-.9,3.284,3.284,0,0,0-2.358-.979",
    transform: "translate(-831.049 -431.733)",
    fill: "#fff"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139228",
    "data-name": "Path 139228",
    d: "M1929.22,567.022c-2.136-3.868-5.1-.817-5.1-.817s-.079-8.019-6.6-7.4c-5.682.541-5.264,8.7-5.264,8.7a3.282,3.282,0,0,0-2.357.979,1.231,1.231,0,0,0-.3.9h25.22a.722.722,0,0,0-.051-.4,3.672,3.672,0,0,0-5.554-1.961",
    transform: "translate(-1708.805 -495.113)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18734",
    "data-name": "Rectangle 18734",
    width: 335.154,
    height: 1.269,
    transform: "translate(3.514 191.912)",
    fill: "#ffc47d"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementsVisual);
export default __webpack_public_path__ + "static/media/achievements_visual.c1d0ed555604fad9a14287bc60e2a80e.svg";
export { ForwardRef as ReactComponent };